import { Component, OnInit, Input, Output, AfterViewInit, ChangeDetectorRef, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CurrencyPipe, Location } from '@angular/common';
import { NavigationExtras, Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';  

import { HTTPService, HelperService, CalculationService, DataService, FormatService } from 'app/services';

import { coreAndReturnMap } from 'app/constants/core-and-return.constants';
import { PartsOrderingRemoveItemDialogComponent } from '../parts-ordering-remove-item-dialog/parts-ordering-remove-item-dialog.component';
import { TireDotNumberDialogComponent } from 'app/modules/app-components/tire-dot-number-dialog/tire-dot-number-dialog.component';
import { PartsLookupDialogComponent } from 'app/modules/app-components/parts-lookup-dialog/parts-lookup-dialog.component';
import { WarrantyEligibleDialogComponent } from 'app/modules/estimate/components';

import { itemTypeIcons, itemTypeLabel } from 'app/constants/itemType.constants';
import { config, messages, tirePositionOptions } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

import { escapeRegExp, find, findIndex, round, trim, sortBy, replace, split } from 'lodash';
import { EngineOilDialogComponent } from 'app/modules/app-components/engine-oil-dialog/engine-oil-dialog.component';
import { TireInOutModalComponent } from 'app/modules/app-components/tire-in-out-modal/tire-in-out-modal.component';
import { NewTireStorageModalComponent } from 'app/modules/app-components/new-tire-storage-modal/new-tire-storage-modal.component';
import { TireStorageDetailsComponent } from 'app/modules/app-components/tire-storage-details/tire-storage-details.component';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-service-item',
  templateUrl: './service-item.component.html',
  styleUrls: ['./service-item.component.scss'],
})
export class ServiceItemComponent implements OnInit, AfterViewInit {
  @Input() invoicedRO: boolean = false;
  @Input() bundleLineItemIndex: number = 0;
  @Input() isQuickbooksCalCompatibiltyOn: boolean = false;
  @Input() isReturnFeatureEnabled: boolean = false;
  @Input() isInventoryEnabled: boolean = false;
  @Input() isDiscountItemEnabled: boolean = false;
  @Input() isArchived: boolean;
  @Input() isArchivedRO: boolean;
  @Input() index: number;
  @Input() isBalanceNegative: any;
  @Input() cardIndex: number;
  @Input() isLast: boolean;
  @Input() serviceItem: any = {};
  @Input() serviceInspection: any;
  @Input() customFleetSettings: any = {};
  @Input() partPricingRule: any = {};
  @Input() partOverRideToApply: any = {};
  @Input() tireOverRideToApply: any = {};
  @Input() tirePricingRule: any = {};
  @Input() adHocMap: any = {};
  @Input() parts: any[] = [];
  @Input() serviceTags: any[] = [];
  @Input() itemTypeOptions: any[] = [];
  @Input() defaultItemTypeOptions: any[] = [];
  @Input() defaultTax: any = {};
  @Input() qboRefs: any = {};
  @Input() serviceId: string = '';
  @Input() estimateId: string = '';
  @Input() customer: any = {};
  @Input() pricingList: any = [];
  @Input() customerId: string = '';
  @Input() vehicleId: string = '';
  @Input() motorVehicle: any = {};
  @Input() serviceTitle: string = '';
  @Input() estimateCode: string = '';
  @Input() remainingAmount: number = 0;
  @Input() motorLaborPricing: any = {};
  @Input() itemSettings: any = {};
  @Input() serviceTech: any = {};
  @Input() vehicleName: string = '';
  @Input() isOtherTaxable: boolean = false;
  @Input() isSubletTaxable: boolean = false;
  @Input() isItemOrderQtyChangeFromALEnabled: boolean = false;
  @Input() isFlatRateSubItem: boolean = false;
  @Input() isPartsOrdingCostEditabled: boolean = false;
  @Input() countOfItemsExistsInFees: any;
  @Input() uniqueInternalReferenceCount: any;
  @Input() hideCost: boolean = true;
  @Input() invoiceType: string = '';
  @Input('hasCore')
  set setHasCore(hasCore: boolean) {
    const index = findIndex(this.serviceActionOptions, { value: 'core' });

    if (index !== -1) {
      this.serviceActionOptions[index].name = hasCore ? 'Update core' : 'Add core';
    }

    if (this.serviceItem.tags) {
      this.serviceItem.tags.forEach((tag: any) => {
        if (tag.name === 'Core') {
          tag.tooltip = `Core: $${Number(this.serviceItem.coreCost).toFixed(2)}`;
        }
      });
    }
  }

  @Input('updatedDefaultCount')
  set setUpdatedDefaultCount(count: number) {
    if (count >= 0) {
      this.defaultService.count = count;
    }
  }

  @Input('hasReturn')
  set setHasReturn(hasReturn: boolean) {
    const index = findIndex(this.serviceActionOptions, { value: 'item' });

    if (index !== -1) {
      this.serviceActionOptions[index].name = hasReturn ? 'Update return' : 'Return to supplier';
    }

    if (this.serviceItem.tags) {
      this.serviceItem.tags.forEach((tag: any) => {
        if (tag.name === 'Returned') {
          tag.tooltip = `Qty returned: ${Number(this.serviceItem.qtyReturn)}`;
        }
      });
    }
  }
  @Input('itemData')
  set setItemData(itemData: any) {
    setTimeout(() => {
      if (!this.isAssociateAutoSelectDone && itemData?._id) {
        this.isAssociateAutoSelectDone = true;
        this.handleSelect(itemData.type, itemData, null, false);
        if (itemData.openItemDialog) {
          this.serviceItem.focusSupplier = true;
          this.appOpenItemModal.emit({
            title: this.title,
            type: this.type,
            openFrom: 'catalog-link',
            serviceId: this.serviceId,
            itemId: this.serviceItem.itemId,
            index: this.index,
            orderId: this.estimateId,
            serviceItem: this.helperService.deepCopy(this.serviceItem),
          });
          delete this.serviceItem.itemData;
          itemData.openItemDialog = false;
        }

        if (['bundle', 'hazmatFee'].includes(itemData.type)) {
          delete this.serviceItem.itemData;
        }
      }
    }, 100);
  }
  @Input('isPartsOrderingDisassociateEnabled')
  set isPartsOrderingDisassociateEnabled(isPartsOrderingDisassociateEnabled: boolean) {
    this._isPartsOrderingDisassociateEnabled = isPartsOrderingDisassociateEnabled;

    this.setItemsActionOption();
  }
  @Input('partOrderingStatus')
  set partOrderingStatus(partOrderingStatus: any[]) {
    this.partOrderingTags = partOrderingStatus || [];
    if (partOrderingStatus && partOrderingStatus.length && this.isInventoryEnabled) {
      this.setItemsActionOption();
    }
  }
  @Input() serviceStatus: string = '';
  @Input() subletPricing: any = {};
  @Input('isUpdatingServices')
  set isUpdatingServices(isLoading: boolean) {
    this.isUpdating = isLoading;
    if (this.isSubletDescriptionUpdating && !isLoading) {
      this.isSubletDescriptionUpdating = isLoading;
    }
  }

  @Input() partsLookupDropDownList: any;
  @Input() isPartsTechConnected: boolean = false;
  @Input() isNexpartConnected: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() bundleItem?: any;
  @Input() currentLang: string = 'en';
  @Input() companyLocalization: boolean = false;
  @Input() warehouses: any = [];

  @Output() rowOnfocus = new EventEmitter();
  @Output() rowOnBlur = new EventEmitter();
  @Output() itemDelete = new EventEmitter();
  @Output() calculateTotal = new EventEmitter();
  @Output() appTagCreated = new EventEmitter();
  @Output() addServiceItem = new EventEmitter();
  @Output() insertServiceItem = new EventEmitter();
  @Output() updateServiceItem = new EventEmitter();
  @Output() appOpenItemModal = new EventEmitter();
  @Output() generateActivity = new EventEmitter();
  @Output() updateTags = new EventEmitter();
  @Output() appOpenReturnDialog = new EventEmitter();
  @Output() addAssociatedItems = new EventEmitter();
  @Output() handleOpenCatalogueDialog = new EventEmitter();
  @Output() handleOpenInventoryDialog = new EventEmitter();
  @Output() appGetAndSelectBundleItem = new EventEmitter();
  @Output() appEmitCostUpdated = new EventEmitter();
  @Output() appHandleOnlinOrderAction = new EventEmitter();
  @Output() refetchPartsOrderingCart = new EventEmitter();
  @Output() appOpenVehicleSpecificLookupDialog = new EventEmitter();
  @Output() appOnEditing = new EventEmitter();
  @Output() removedPartsLookupAndReplace = new EventEmitter();
  @Output() appOnFETFeeUpdate = new EventEmitter();
  @Output() appOpenAssignSaleCodeModal = new EventEmitter();
  @Output() appOpenVehicleAction = new EventEmitter();
  @Output() appRefreshTsInspection = new EventEmitter();

  @ViewChild('stockTooltipEl') stockTooltipEl: any;
  @ViewChild('op') overlayPanel1!: any;
  @ViewChild('op2') overlayPanel2!: OverlayPanel;
  @ViewChild('innerTrigger') innerTrigger!: ElementRef;
  @ViewChild('forceClick') forceClick: ElementRef<HTMLElement>;

  defaultCheck: boolean = false;
  isDialogOpening: boolean = false;
  hideAddToStorage: boolean = false;
  _isPartsOrderingDisassociateEnabled: boolean = false;
  isAssociateAutoSelectDone: boolean = false;
  isCheckingAvailability: boolean = false;
  isUpdatingQuantity: boolean = false;
  isPrintingLabel: boolean = false;
  serviceDiscount: number = 0;
  typeQuery: string = '';
  config: any = config;
  isCreateTagFieldVisible: boolean = false;
  isSearching: boolean = false;
  tagResults: any;
  isTaxable: boolean = false;
  title: string = '';
  discountType: any = this.helperService.deepCopy(config.estimate.discountType[0]);
  defaultTitle: string = '';
  type: any = 'labor';
  selectedType: any = {};
  itemResults: any = [];
  priceSuggestions: any = [];
  partOrderingTags: any[] = [];
  tagTypeService: string = config.tags.service;
  defaultTypeOptions: any[] = this.helperService.deepCopy(this.itemTypeOptions);
  discount = {
    percentage: 0,
    value: 0,
  };
  acFocus: any = {
    row: false,
    type: false,
    description: false,
    price: false,
    count: false,
    subTotal: false,
    status: false,
  };
  acFocusLabel: any = {
    type: 'Select Type',
    description: 'Description',
    price: 0,
    count: 0,
    discount: 0,
    subTotal: 0,
    status: '',
  };
  labels = itemTypeLabel;
  placeholder = {
    part: 'part',
    labor: 'labor',
    tire: 'tire',
    other: 'other',
    hazmatFee: 'fees',
    tireStorage: 'tire storage',
    discount: 'discount',
    sublet: 'sublet',
    partLookUp: 'part',
  };
  icons = itemTypeIcons;
  focus: any = {
    type: false,
    description: false,
    price: false,
    quantity: false,
  };
  errors: any = {
    type: false,
    description: false,
    price: false,
    quantity: false,
  };
  searchQuery = '';
  usd = currency.USD;
  isNewServiceAdded: boolean = false;
  isMotorEnabled: boolean = false;
  hasDividedResults: boolean = false;
  defaultService: any = {};
  secondarySuggestions: any[] = [];
  primarySuggestions: any[] = [];
  skillType = ['General', 'Precision', 'Maintenance'];
  searchTypeIcon = itemTypeIcons;
  serviceActionOptions: any[] = [];
  stockTooltip: string = 'Click to view Qtys in Inventory';
  isStocksLoading: boolean = false;
  Number = Number;
  isNaN = isNaN;
  isOverrideCostWithTechRate: boolean = false;
  availableQty: number = 0;
  qtyUpdateError: string = '';
  isValidNexPartEdit: boolean = true;
  partsOrderingIcons: any = {
    Nexpart: 'assets/img/nexpart_logo_outline.svg',
    PartsTech: 'assets/img/Partstech.svg',
    PartsLookup: 'assets/img/lookup.svg',
  };
  dotIcon: string;
  dotIconTooltip: string;
  tireStorageInfoIcon: string;
  tireStorageIconTooltip: string;
  tireStorageTemplates: any = [];
  tirePositionOptions: any[] = tirePositionOptions;
  isDotNumberReqOnInv: boolean = false;
  dotNumberTooltiponDisabled: string = 'DOT numbers cannot be added for tires on deferred or decline services. Please approve service to add DOT numbers.';
  isUpdating: boolean = false;
  isSubletDescriptionUpdating: boolean = false;
  isInventoryReturnEnabled: boolean = false;
  isAttributeBasedPricingEnable: boolean = false;

  isMultiLocationEnabled: boolean = false;
  isStockTransferEnabled: boolean = false;
  isTireStorage2Enabled: boolean = false;
  tireStorageV2OutData: any = [];
  tireStorageCount: string = '';
  outerArrowPosition = 'arrow-top'; // Default for outer overlay
  innerArrowPosition = 'arrow-top'; // Default for inner overlay

  // parts lookup dialog variables
  selectedItem: any[] = [];
  disableInventoryOrder: boolean = true;
  isProcessing: boolean = false;
  quickLookupSelection: any[] = [];
  copiedIndex: number;
  hideOverlayTimeout: any;
  visibleItems: any[] = [];
  maxCharacters = 90; // Max total character count allowed
  preferredInventoryOnlineLookup: string = '';
  tireStorageV2Category: any = {};

  constructor(
    private dialogService: DialogService,
    public helperService: HelperService,
    private httpService: HTTPService,
    private cdr: ChangeDetectorRef,
    private calculationService: CalculationService,
    private currencyPipe: CurrencyPipe,
    private dataService: DataService,
    private router: Router,
    private formatService: FormatService,
    private location: Location,
  ) { }

  async ngOnInit() {
    this.defaultItemTypeOptions = this.helperService.deepCopy(this.itemTypeOptions);
    this.preferredInventoryOnlineLookup = this.dataService.preferredInventoryOnlineLookup;

    this.reorderLaborItem();

    this.quickLookupSelection = this.dataService.lookupQuickSelection;
    this.isOverrideCostWithTechRate = this.dataService.isOverrideCostWithTechRate;
    this.isDotNumberReqOnInv = this.dataService.isDotNumberReqOnInv;
    this.isAttributeBasedPricingEnable = this.dataService.isAttributeBasedPricingEnable;
    this.isInventoryReturnEnabled = this.dataService.isInventoryReturnEnabled;
    this.isStockTransferEnabled = this.dataService.isStockTransferEnabled;
    this.isMultiLocationEnabled = this.helperService.getCompany().isMultiLocationEnabled;
    this.isTireStorage2Enabled = this.dataService.isTireStorage2Enabled;
    if (this.serviceItem.isFocusTitle) {
      setTimeout(() => {
        this.focus.titleSearch = true;
        this.serviceItem.invalid = false;
      }, 1000);
    }
    if (this.serviceItem.type) {
      this.selectedType = {
        label: this.labels[this.serviceItem.type] || '',
        value: this.serviceItem.type,
      };
      this.type = this.serviceItem.type;
      this.isNewServiceAdded = true;
    } else {
      this.serviceItem.type = '';
      this.type = this.serviceItem.type;
    }

    if (this.serviceItem.discount && this.serviceItem.discount.value) {
      const { type, value } = this.serviceItem.discount;

      const [data] = config.estimate.discountType.filter((d) => d.type === type);
      this.discountType = this.helperService.deepCopy(data);
      this.acFocusLabel.discount = value;
    }

    if (this.serviceItem.coreRetrievalStatus) {
      for (let i = 0; i < this.serviceItem.tags.length; i++) {
        if (this.serviceItem.tags[i]?.name?.startsWith('Core: ')) {
          this.serviceItem.tags[i].name = `Core: ${coreAndReturnMap[this.serviceItem.coreRetrievalStatus]}`;
        }
      }
    }

    if (this.serviceItem.type === 'sublet') {
      this.serviceItem.tags = this.serviceItem.tags.map((tag) => {
        if (tag.name === 'Supplier unassigned' || tag.name === 'Supplier assigned' || tag.name === 'Sublet') {
          return { ...tag, default: true };
        }
        return tag;  
      });
      this.serviceItem.tags = this.serviceItem.tags.filter((tag) => tag != null); 
    }

    // if (this.serviceItem.tags?.length) {
    //   this.serviceItem.tags.forEach((element) => {
    //     if (element.name === 'SC Unassigned' && this.serviceItem.category?.categoryId) {
    //       element.tooltip = 'The item classification for this item does not belong to any Sales Code';
    //     } else if (element.name === 'No Class' && !this.serviceItem.category?.categoryId) {
    //       element.tooltip = 'Item classification is missing for this item. Please add the item classification so a Sales Code can be assigned or ask the admin to do so';
    //     }
    //   });
    // }

    /** @todo we are not using it need to verify and remove */
    if (this.serviceItem.type === 'part') {
      this.isTaxable = this.serviceItem.isTaxable && this.defaultTax.parts;
    } else if (this.serviceItem.type === 'labor') {
      this.isTaxable = this.serviceItem.isTaxable && this.defaultTax.labor;
      // if (this.isOverrideCostWithTechRate && this.serviceItem.avgTechCost > 0) {
      //   this.serviceItem.cost = this.serviceItem.avgTechCost * this.serviceItem.costEstimatedHours;
      // }
    } else if (this.serviceItem.type === 'tire') {
      this.isTaxable = this.serviceItem.isTaxable && this.defaultTax.tire;
    } else if (this.serviceItem.type === 'other') {
      this.isTaxable = this.serviceItem.isTaxable && this.defaultTax.other;
    }
    this.defaultTitle = this.serviceItem.title;

    if (this.serviceItem.type && !['other', 'sublet', 'partLookUp'].includes(this.serviceItem.type) && !this.serviceItem.itemId) {
      this.serviceItem.invalid = true;
      if (this.serviceItem.type === 'partLookUp') {
        // this.serviceItem.itemId = 'no-id';
      }
    } else {
      this.serviceItem.invalid = false;
    }

    this.discountType = this.helperService.deepCopy(this.serviceItem.discount);

    if (this.discountType && this.discountType.type) {
      this.discountType.name = this.discountType.type === 'value' ? 'Fixed' : 'Percent';
    }

    // if(this.serviceItem.type === 'tireStorage' && this.isTireStorage2Enabled) this.serviceItem.title = `Tires In-${this.serviceItem.title}`;

    //if(this.isTireStorage2Enabled) this.setTireStorageTemplate();
    this.setItemsActionOption();
    this.calculateDiscountAndValue();
    this.defaultService = this.helperService.deepCopy(this.serviceItem);
    this.setDotNumberIcon();
    this.setDotNumberTooltip(this.serviceItem.dotNumbers);
    if (this.isTireStorage2Enabled && this.serviceItem.type === 'tireStorage') {
      this.setTireStorageInfoTooltip(true);
      if(!this.serviceItem.description){
        const res = await this.getTireStorageData(this.serviceItem.itemId);
        if(res.item && res.item.tiresInfo) this.populateTireStorageDescription(res.item.tiresInfo)
      }
    }
    if (this.dataService.isPartWarrantiesEnabled && this.dataService.isWarrantyNumberAddonEnabled) {
      this.setWarrantyNumberTag();
    }
  }

  reorderLaborItem() {
    const laborIndex = this.itemTypeOptions.findIndex((item) => item.highlightField === 'labor');

    if (laborIndex !== -1) {
      const laborItem = this.itemTypeOptions[laborIndex];

      this.itemTypeOptions = [
        laborItem,
        ...this.itemTypeOptions.filter((item) => item.highlightField !== 'labor')
      ];
    }
  }


  setTireStorageTemplate(search = '') {
    const conf = {
      limit: 1000,
      sortField: 'title',
      sortOrder: 1,
      search,
      activeStatus: true,
    };
    this.httpService.getItems({ ...conf, type: 'tireStorageTemplate' }).then(
      (data: any) => {
        this.tireStorageTemplates = [];
        if (data?.records?.length) {
          const sortedData = sortBy(data.records, (item: any) => { return item?.title });
          this.tireStorageTemplates = sortedData || data.records;
          this.tireStorageTemplates.push({ isTireOut: true, title: 'Tires Out' });
          this.itemResults = [...this.tireStorageTemplates];
          this.hasDividedResults = true;
          this.isSearching = false;
        } else {
          if(!search) this.showEmptyTireStorageDialog();  
        }
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  showEmptyTireStorageDialog() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog carfax-customized-confirmation',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
         isHTML: true,
         styleClassHeading: 'font-18 font-700',
         styleClassCloseIcon: 'font-24 font-400 font-gray',
        headerIcon: 'far fa-tire ml',
        headerIconType: 'header-icon-primary',
        title: 'No Tire Storage Packages Found',
        message: `You need to create at least one tire storage package in your
        catalog before you can store tires. Would you like to set one up now?`,
        button: {
          success: { title: 'Set Up Package', styleClass: 'btn-primary', },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      this.isSearching = false;
      if (isSuccess) {
        this.helperService.openPageInNewTab(`catalog/tire-storage/isCreateTireStorage`);
      }

      onClose.unsubscribe();
    });
  }
  
  isTireInTemplates() {
    return this.tireStorageTemplates?.filter(element => !element.isTireOut);
  }

  setWarrantyNumberTag() {
    if (this.invoicedRO && ['part', 'tire', 'bundle'].includes(this.serviceItem?.type) && this.serviceItem?._id) {
      if (this.serviceItem?.type === 'bundle') {
        if (this.serviceItem?.subItems?.length) {
          this.serviceItem?.subItems.forEach((subItem: any) => {
            if (subItem?.isWarrantyEligible && subItem?.warranty?.warrantyNumber) {
              const index = findIndex(subItem.tags, { tagType: 'warrantyNo' });
              if (index < 0) {
                subItem.tags.push({
                  color: '#3D7EAD',
                  name: subItem?.warranty?.warrantyNumber,
                  tagType: 'warrantyNo',
                  tooltip: subItem?.warranty?.warrantyNumber,
                });
              }
            }
          });
        }
      } else {
        if (this.serviceItem?.isWarrantyEligible && this.serviceItem?.warranty?.warrantyNumber) {
          const index = findIndex(this.serviceItem.tags, { tagType: 'warrantyNo' });
          if (index < 0) {
            this.serviceItem.tags.push({
              color: '#3D7EAD',
              name: this.serviceItem?.warranty?.warrantyNumber,
              tagType: 'warrantyNo',
              tooltip: this.serviceItem?.warranty?.warrantyNumber,
            });
          }
        }
      }
    }
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    this.filterVisiblePills();
  }

  filterVisiblePills(): void {
    let remainingCharacters = this.maxCharacters;
    this.visibleItems = [];

    for (const item of this.quickLookupSelection) {
      const nameLength = item.name.length;

      if (nameLength <= remainingCharacters) {
        this.visibleItems.push(item);
        remainingCharacters -= nameLength;
      } else {
        break;
      }
    }

    this.cdr.detectChanges();
  }

  setSubletItemActionTooltip(actions: any) {
    let index = findIndex(this.serviceItem.tags, { name: 'Completed' });
    if (index > -1) {
      actions.delete.disabled = true;
      actions.delete.tooltip = 'Complete or payable sublet items cannot be deleted. Please adjust the item status if deletion is required';
    }
    index = findIndex(this.serviceItem.tags, { name: 'Paid' });
    if (index > -1) {
      actions.delete.disabled = true;
      actions.delete.tooltip = 'Paid sublet items cannot be deleted to ensure accurate financial tracking.';
    }

    // index = findIndex(this.serviceItem.tags, {name: 'Supplier assigned'});
    // if(index > -1) {
    //   actions.subletSupplier.name = 'Update sublet suppliers';
    // }
  }

  setItemsActionOption() {
    const actions: any = {
      'update-supplier': { deleted: true, name: 'Update supplier', value: 'update-supplier' },
      'print-label': { deleted: true, name: 'Print label', value: 'print-label' },
      item: { deleted: false, name: 'Return to supplier', value: 'item' },
      inventory: { deleted: true, name: 'Add to inventory', value: 'inventory' },
      core: { deleted: false, name: 'Add core', value: 'core' },
      subletSupplier: { deleted: true, name: `Update sublet suppliers`, value: 'subletSupplier' },
      delete: { deleted: false, name: 'Delete', value: 'delete' },
      remove: { deleted: true, name: 'Remove', value: 'remove' },
      duplicate: { deleted: true, name: 'Duplicate', value: 'duplicate' },
      disassociate: { deleted: true, name: `Disassociate from service`, value: 'disassociate' },
      stockTransferReceive: { deleted: true, name: `Receive item via transfer`, value: 'stockTransferReceive' },
      stockTransferSend: { deleted: true, name: `Send item via transfer`, value: 'stockTransferSend' },
    };

    if (!['part', 'tire'].includes(this.serviceItem.type)) {
      actions.item.deleted = true;
      actions.inventory.deleted = true;
      actions.core.deleted = true;
      actions.remove.deleted = true;
      actions.disassociate.deleted = true;
    } else {
      if (this.serviceItem.stocked) {
        actions.inventory.deleted = true;
      } else {
        if (!this.serviceItem.isManualOrderItem) {
          actions.item.deleted = true;
        }
        actions.inventory.deleted = false;
      }

      if (this.isMultiLocationEnabled && this.isStockTransferEnabled && ['part', 'tire'].includes(this.serviceItem.type)) {
        actions.stockTransferReceive.deleted = false;
        actions.stockTransferSend.deleted = false;
      }
    }

    if (!this.serviceItem?.hasCore) {
      actions.core.deleted = true;
    }

    if (this.serviceItem?.lineItemType === 'refund') {
      actions.duplicate.deleted = false;
    }

    if (!this.isReturnFeatureEnabled) {
      actions.item.deleted = true;
      actions.core.deleted = true;
    }

    if (this.serviceItem.type === 'tireStorage') {
      if (this.serviceItem.tireStorageStatus === 'store') {
        actions['print-label'].deleted = false;
        if(this.isArchived) {
          actions['delete'].deleted = true;
        }
      }
    }

    if (['part', 'tire'].includes(this.serviceItem.type) && this.serviceItem.orderItemId) {
      const sources = ['PartsTech', 'TireHub', 'TireConnect', 'RepairLink', 'Nexpart'];
      if (this._isPartsOrderingDisassociateEnabled) {
        actions['update-supplier'].deleted = false;
        actions.remove.deleted = false;
        actions.item.deleted = false;
        actions.delete.deleted = true;
      }

      if (sources.includes(this.serviceItem.itemSource) && this.isItemOrderQtyChangeFromALEnabled) {
        actions.remove.deleted = false;
        actions.disassociate.deleted = false;
      }
    }

    if (this.serviceItem.type === 'sublet') {
      actions.subletSupplier.deleted = false;
      actions.delete.deleted = false;
      actions.core.deleted = true;
      actions.item.deleted = true;
      this.setSubletItemActionTooltip(actions);
    }

    if (this.serviceItem?.type === 'hazmatFee' && this.serviceItem?.isPassThroughFet) {
      actions.delete.disabled = true;
      actions.delete.tooltip = 'This FET fee is associated with a commercial tire. To remove it, please delete the tire or set its FET rate to $0.00';
    }

    this.serviceActionOptions = [...Object.values(actions).filter(({ deleted }: any) => !deleted)];
    if (this.serviceItem?.lineItemType === 'refund') {
      this.serviceActionOptions = [
        {
          deleted: false,
          name: 'Duplicate',
          value: 'duplicate',
        },
        {
          deleted: false,
          name: 'Delete',
          value: 'delete',
        },
      ];
    }
  }

  setCoreDetails() {
    if (!this.serviceItem) return;
  }

  handleTitleChange(title: string) {
    this.title = title;
  }

  handleFocus(type: string) {
    if (this.isArchived) {
      return;
    }
    this.focus[type] = true;
    this.errors[type] = '';
    this.appOnEditing.emit({ serviceCardIndex: this.cardIndex, isEditing: true });
  }

  setSubletTags() {
    const subletTag = find(this.serviceTags, { name: 'Sublet' });
    const supplierUnassignedTag = find(this.serviceTags, { name: 'Supplier unassigned' });
    if (subletTag && findIndex(this.serviceItem.tags, { name: 'Sublet' }) < 0) {
      this.serviceItem.tags = [...this.serviceItem.tags, ...[{ ...subletTag, tagId: subletTag._id }]];
    }
    if (supplierUnassignedTag && findIndex(this.serviceItem.tags, { name: 'Supplier unassigned' }) < 0 && findIndex(this.serviceItem.tags, { name: 'Supplier assigned' }) < 0) {
      this.serviceItem.tags = [...this.serviceItem.tags, ...[{ ...supplierUnassignedTag, tagId: supplierUnassignedTag._id }]];
    }
    this.serviceItem.tags = this.serviceItem.tags.map(item =>  ({...item, default : true}));
  }

  async handleBlur(type: string) {
    this.focus[type] = false;

    if (this.serviceItem.type === 'tireStorage' && this.isTireStorage2Enabled) {
      if (this.serviceItem.count > 6) {
        this.helperService.showToaster('error', messages.tireStorageCountMessage);
        // this.setTireStorageInfoTooltip();
        setTimeout(() => {
          this.serviceItem.count = '6';
          this.updateInspection();
          this.cdr.detectChanges();
        }, 500);
      }
    }

    if (['sublet', 'other'].includes(this.serviceItem.type)) {
      if (!(this.serviceItem.title || this.serviceItem.titleFr)) {
        this.errors.title = true;

        if (this.serviceItem.type === 'sublet') return;
      } else {
        this.errors.title = false;
      }
    }

    if (type === 'cost' && (this.defaultService.cost === '.' || this.serviceItem.cost === '.')) {
      this.defaultService.cost = 0;
      this.serviceItem.cost = 0;
    }

    if (['hazmatFee', 'tire'].includes(this.serviceItem?.type) && ['price', 'count'].includes(type)) {
      if (this.serviceItem?.fetValue >= 0 || this.serviceItem.isPassThroughFet) {
        this.appOnFETFeeUpdate.emit({ lineItem: this.serviceItem });
        if (this.serviceItem?.type === 'hazmatFee' && type === 'price' && this.serviceItem.isPassThroughFet) {
          this.serviceItem.cost = this.serviceItem.price;
        }
      }
    }

    if (type === 'cost' && this.serviceItem.type === 'sublet') {
      if (this.subletPricing && this.subletPricing.sublet && this.serviceItem.cost > 0) {
        const markup = this.subletPricing.sublet.markup;

        const price: any = this.calculationService.calculateMarkUpPrice(this.serviceItem.cost, markup);
        //Adding a fix for the ALP-16938 issue. Basically in case of sublet if price is added manually then no need to calculate pricing matrix.
        //if (!this.serviceItem?.price) {
        //removing if not price conditions against ticket ALP-18692 as per on demand from the Product side although its conflicting the above mentioned ticket and it will revert back the above comment ticket
        if(!this.serviceItem?.price) {
        this.serviceItem.price = this.calculationService.roundOff(price);
        }
        //}

        this.calculatePrice();
        this.calculateDiscountAndValue();
        this.saveDiscount(null);
      }
    }

    if (this.serviceItem.lineItemType === 'refund') {
      if (type === 'price') {
        if (Math.abs(Number(this.serviceItem.price)) > Math.abs(Number(this.serviceItem.originalPrice))) {
          this.serviceItem.price = this.defaultService.price;
          this.helperService.showToaster('error', 'Returned price cannot be more than original price');
        } else if (!this.serviceItem.price) {
          this.serviceItem.price = this.defaultService.price;
          this.helperService.showToaster('error', 'Returned price cannot be zero');
        }
      }

      if (type === 'count') {
        if (Math.abs(Number(this.serviceItem.count)) > Math.abs(Number(this.serviceItem.originalCount))) {
          this.serviceItem.count = this.defaultService.count;
          this.helperService.showToaster('error', 'Returned Qty/Hrs cannot be more than original Qty/Hrs');
        } else if (!this.serviceItem.count) {
          this.serviceItem.count = this.defaultService.count;
          this.helperService.showToaster('error', 'Returned Qty/Hrs cannot be zero');
        } else if (this.serviceItem.count > 0) {
          this.serviceItem.count = this.serviceItem.count * -1;
        }
      }
    }

    if (['price', 'count'].includes(type)) {
      this.calculatePrice();
      this.calculateDiscountAndValue();
      this.saveDiscount(null);
    }

    if (this.dataService.isSalesCodeEnabled && ['sublet', 'other'].includes(this.serviceItem.type)) {
      this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
    }

    if (!['discountValue', 'updateCost'].includes(type)) {
      if (this.serviceItem.type === 'sublet' && type === 'description') {
        this.isUpdating = true;
        this.isSubletDescriptionUpdating = true;
        this.setSubletTags();
        this.setItemsActionOption();
        if (!this.serviceItem?.itemInternalReference) {
          this.serviceItem.itemInternalReference = `${this.serviceId}-${this.uniqueInternalReferenceCount.count++}`;
        }
      }

      if (type !== 'tireStorage' || !this.isTireStorage2Enabled) this.saveServiceItem();
    }

    if (['part', 'labor', 'tire', 'tireStorage', 'hazmatFee'].includes(type)) {
      if (this.serviceItem.type && this.serviceItem.type !== 'other' && !this.serviceItem.itemId) {
        this.serviceItem.invalid = true;
      } else {
        this.serviceItem.invalid = false;
        if (this.companyLocalization && this.currentLang === 'fr' && this.defaultTitle) {
          this.serviceItem.titleFR = this.defaultTitle;
        } else {
          this.serviceItem.title = this.defaultTitle;
        }
      }
    }

    if (type === 'type' && this.type) {
      this.selectedType = {
        ...this.selectedType,
        label: this.labels[this.type],
      };
    }

    if(type === 'description' && ['sublet'].includes(this.serviceItem.type) && !this.serviceItem.itemId){ 
      let text = `RO# ${this.estimateCode}: ${this.labels[this.serviceItem.type]} (${this.serviceItem.title || this.serviceItem?.titleFR}) of value\
        $${Number(this.serviceItem.subTotal).toFixed(2)} was added to the Service "${this.serviceTitle}"`;
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        isPrimary: false,
        activityData: { type: 'plaintext', icon: [this.icons[this.serviceItem.type]] },
        title: `${this.labels[this.serviceItem.type]} added`,
        text,
      });
    }

    if (type === 'price' && Number(this.defaultService.price) !== Number(this.serviceItem.price)) {
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        activityData: {
          type: 'plaintext',
          icon: this.icons[this.serviceItem.type],
        },
        isPrimary: false,
        title: `${this.labels[this.serviceItem.type]} price updated`,
        // tslint:disable-next-line: max-line-length
        text: `RO# ${this.estimateCode}: Price of ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle}" was updated from $${Number(
          this.defaultService.price || 0,
        ).toFixed(2)} to $${Number(this.serviceItem.price).toFixed(2)}`,
      });
      this.serviceItem.isPriceChanged = true;
      this.defaultService.price = this.serviceItem.price;
    } else if (type === 'cost' && Number(this.defaultService.cost) !== Number(this.serviceItem.cost)) {
      if (this.isManualOrderExist()) {
        this.helperService.showToaster('error', 'Update supplier parts ordering cost on parts ordering screen based on the updated Service line cost');
      }
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        activityData: {
          type: 'plaintext',
          icon: this.icons[this.serviceItem.type],
        },
        isPrimary: false,
        title: `${this.labels[this.serviceItem.type]} cost updated`,
        text: `Service - ${this.serviceTitle}: Cost of ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle}" was updated from $${Number(
          this.defaultService.cost || 0,
        ).toFixed(2)} to $${Number(this.serviceItem.cost).toFixed(2)}`,
      });

      if (this.Number(this.defaultService.cost) !== Number(this.serviceItem.cost)) {
        this.appEmitCostUpdated.emit({ pCost: this.defaultService.cost, nCost: this.serviceItem.cost });
      }

      this.defaultService.cost = this.serviceItem.cost;
    } else if ((type === 'count' || type === 'updateCount') && Number(this.defaultService.count) !== Number(this.serviceItem.count)) {
      this.calculateDotNumbers(true);
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        activityData: {
          type: 'plaintext',
          icon: this.icons[this.serviceItem.type],
        },
        isPrimary: false,
        title: `${this.labels[this.serviceItem.type]} quantity updated`,
        // tslint:disable-next-line: max-line-length
        text: `RO# ${this.estimateCode}: Quantity of ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle}" was updated from ${Number(
          this.defaultService.count,
        )} to ${Number(this.serviceItem.count)} `,
      });

      if (this.serviceItem.type === 'labor') {
        let estimateHours = this.calculationService.roundOff(this.serviceItem.costEstimatedHours);

        if (estimateHours === 0) {
          estimateHours = this.serviceItem.count;
        }
        
        this.serviceItem.costEstimatedHours = this.calculationService.roundOff(this.calculationService.roundOff(Number(this.serviceItem.count)));
        this.serviceItem.cost = this.calculationService.roundOff(
          this.calculationService.roundOff(this.defaultService.cost / this.defaultService.costEstimatedHours) * this.serviceItem.costEstimatedHours,
        );
        //this.serviceItem.cost = this.calculationService.roundOff(this.calculationService.roundOff((Number(this.serviceItem.count) / Number(this.defaultService.count))) * this.serviceItem.cost);
        this.generateActivity.emit({
          entityId: this.serviceId,
          entityType: 'service',
          forTechOnly: true,
          tech: this.serviceTech || {},
          entityAction: 'updated',
          activityData: {
            type: 'plaintext',
            icon: this.icons[this.serviceItem.type],
          },
          isPrimary: false,
          title: `Service Updated`,
          // tslint:disable-next-line: max-line-length
          text: `The total labor hours of service ${this.serviceItem.title}) for ${this.vehicleName} were updated from ${Number(this.defaultService.count)} hours to ${Number(
            this.serviceItem.count,
          )} hours`,
        });
      }

      this.defaultService.count = Number(this.serviceItem.count);
    } else if (
      (type === 'notes' && Number(this.defaultService.description) !== Number(this.serviceItem.description)) ||
      Number(this.defaultService.descriptionFR) !== Number(this.serviceItem.descriptionFR)
    ) {
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        activityData: {
          type: 'plaintext',
          icon: this.icons[this.serviceItem.type],
        },
        isPrimary: false,
        title: `${this.labels[this.serviceItem.type]} description updated`,
        text: `RO# ${this.estimateCode}: Description of ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle}" was updated from ${this.defaultService.description || ''
          } to ${this.serviceItem.description || ''}`,
      });

      this.defaultService.description = this.serviceItem.description;
      if (this.companyLocalization && this.currentLang === 'fr') {
        this.defaultService.descriptionFR = this.serviceItem.descriptionFR;
      }
      if (this.isTireStorage2Enabled && this.serviceItem.type === 'tireStorage') {
        if (this.serviceItem.itemId) {
          const response: any = await this.httpService.initItemData('tireStorage', this.serviceItem.itemId);
          response.item.description = this.serviceItem.description;
          if (this.companyLocalization && this.currentLang === 'fr') {
            response.item.descriptionFR = this.serviceItem.descriptionFR;
          }
          this.httpService.updateItem(response.item).then((res: any) => { });
        }
      }
    }
  }

  updateInspection(isFromTemplate = false) {
    if (this.serviceItem.associatedInspection && this.serviceItem.associatedInspection?.inspectionId) {
      this.httpService.initItemData('tireStorage', this.serviceItem.itemId).then((res: any) => {
        if (res.item?.tiresInfo) {
          if (this.serviceItem.count > res.item.tiresInfo.length && res.item.tiresInfo.length > 0) {
            const diff = this.serviceItem.count - res.item.tiresInfo.length;
            for (var i = 0; i <= diff - 1; i++) {
              const lastTire = this.helperService.deepCopy(res.item.tiresInfo[res.item.tiresInfo.length - 1]);
              const index = findIndex(this.tirePositionOptions, { name: lastTire.tireLabel });
              if (index !== -1 && index < 5) {
                const updTire = { ...this.tirePositionOptions[index + 1] };
                const prevTire = {
                  model: lastTire.model,
                  size: lastTire.size || '',
                  seasonality: lastTire.seasonality,
                  storageBin: lastTire.storageBin || null,
                  tireLabel: updTire.name,
                  rimType: lastTire.rimType,
                  storageLocation: lastTire.storageLocation,
                  brand: lastTire.brand,
                  class: updTire.class,
                };
                res.item.tiresInfo.push(prevTire);
              }
            }
          } else if (this.serviceItem.count < res.item.tiresInfo.length) {
            const diff = res.item.tiresInfo.length - this.serviceItem.count;
            res.item.tiresInfo = res.item.tiresInfo.slice(0, -diff);
          }

          this.httpService.updateItem(res.item).then((response: any) => {
            const conf = {
              tiresInfo: response?.tiresInfo,
              isEditBlank: !!!res.item.tiresInfo?.length,
              tireCount: this.serviceItem.count,
            };
            if (this.serviceInspection && this.serviceInspection._id && this.serviceItem.count > 0) {
              this.httpService.updateStorageInspection(conf, this.serviceInspection._id).then((res) => {
                this.appRefreshTsInspection.emit(res);
              });
            }
            if (this.isTireStorage2Enabled) {
              this.setTireStorageInfoTooltip();
            }
          });
        }
        // if(isFromTemplate)this.setTireStorageInfoTooltip();
      });
    }
  }

  calculateDotNumbers(isFromBlur?: boolean) {
    //Adding a fix in case of ajdustment invoices for ALP-20357
    const itemCount = this.serviceItem.count >= 0 ? this.serviceItem.count : this.serviceItem.count * -1;
    if (Number(itemCount) > 0 && this.serviceItem.dotNumbers?.length > Number(itemCount)) {
      const noOfElements = this.serviceItem.dotNumbers.length - Number(itemCount);
      const emptyRowIndex = findIndex(this.serviceItem.dotNumbers, (item: any) => {
        return !item?.dotNumber && !item?.tirePosition;
      });
      if (emptyRowIndex > -1) {
        this.serviceItem.dotNumbers.splice(emptyRowIndex, noOfElements);
      } else {
        this.serviceItem.dotNumbers.splice(this.serviceItem.dotNumbers.length - noOfElements, noOfElements);
      }

      this.saveServiceItem();
    } else if (this.serviceItem.dotNumbers?.length < (Number(this.serviceItem.count) < 0 ? Number(this.serviceItem.count) * -1 : Number(this.serviceItem.count))) {
      const count = Number(this.serviceItem.count) < 0 ? Number(this.serviceItem.count) * -1 : Number(this.serviceItem.count);
      const newDotNumbers = count - this.serviceItem.dotNumbers.length;
      for (var i = 0; i < newDotNumbers; i++) {
        this.serviceItem.dotNumbers.push({ dotNumber: '', tirePosition: '' });
      }
      if (isFromBlur && this.isDotNumberReqOnInv) {
        this.serviceItem.checkDotNumberRequired = true;
      } else {
        this.serviceItem.checkDotNumberRequired = false;
      }
      this.saveServiceItem();
    }
    this.setDotNumberTooltip(this.serviceItem.dotNumbers);
    this.setDotNumberIcon();
  }

  handleTypeSearch(query: string) {
    this.itemTypeOptions = [...this.defaultItemTypeOptions.filter(({ highlightField }) => new RegExp(query, 'i').test(highlightField))];
    this.reorderLaborItem();
  }

  handleClear(type: string) {
    if (type === 'type') {
      this.itemTypeOptions = [...this.defaultItemTypeOptions];
      this.reorderLaborItem();
    }
  }

  handleClearService(serviceItem) {
    this.itemResults = [];
    this.secondarySuggestions = [];
    this.primarySuggestions = [];
    if (serviceItem.type === 'partLookUp') {
      this.itemResults = this.partsLookupDropDownList;
    }
    this.searchQuery = '';
    if (this.isTireStorage2Enabled) this.searchSuggestion(this.searchQuery, this.type);
  }

  handleTagDelete(deletedTag: any) {
    if (this.serviceTags && this.serviceTags.length) {
      this.serviceTags = this.serviceTags.filter(tag => {
        if (deletedTag._id) {
          return tag._id !== deletedTag._id;
        } else {
          return !(tag.name === deletedTag.name && tag.color === deletedTag.color);
        }
      });
    }
  }
  
  handleChange(type: string, value: string) {
    this.serviceItem[type] = value;

    if (type === 'price') {
      if (this.serviceItem?.type === 'tireStorage' && this.serviceItem.pricingType === 'flatFee') {
        this.serviceItem.mockFlatPrice = value
        this.serviceItem.price = Number(value) / Number(this.serviceItem.count);
      } else {
        this.serviceItem.price = value;
      }

      this.calculatePrice();
    } else if (type === 'count') {
      if (this.serviceItem.type === 'tireStorage' && this.isTireStorage2Enabled) {
        if (Number(value) <= 6) {
          this.serviceItem.count = value;
          // this.tireStorageCount = value;
          this.setPriceCostTS(true);
        }
      } else {
        this.serviceItem.count = value;
        this.calculatePrice();
      }
    } else if (this.isTireStorage2Enabled && type === 'cost' && this.serviceItem?.tireStorageStatus !== 'retrun' && this.serviceItem?.type === 'tireStorage' && this.serviceItem.pricingType === 'flatFee') {
      this.serviceItem.mockFlatCost = value;
      this.serviceItem.cost = Number(value) / Number(this.serviceItem.count);
    }

    if (type === 'notes') {
      if (this.currentLang.toLowerCase() === 'fr') {
        this.serviceItem.descriptionFR = value;
      } else {
        this.serviceItem.description = value;
      }
    }

    if (!this.isNewServiceAdded) {
      this.addServiceItem.emit({});
      this.isNewServiceAdded = true;
    }
  }

  setPriceCostTS(updateInspection = false) {
    if (this.serviceItem.pricingType && this.serviceItem.pricingType === 'flatFee' && Number(this.serviceItem.count)) {
      this.serviceItem.mockFlatPrice = this.serviceItem.originalPrice;
      this.serviceItem.mockFlatCost = this.serviceItem.originalCost;
      this.serviceItem.price = this.serviceItem.originalPrice / Number(this.serviceItem.count);
      this.serviceItem.cost = this.serviceItem.originalCost / Number(this.serviceItem.count);
    } else {
      if (this.serviceItem.pricingType === 'perTire') this.calculatePrice();
    }
    if (updateInspection) {
      // TODO: Needs to update this.
      setTimeout(() => {
        this.updateInspection();
        this.cdr.detectChanges();
      }, 500);
    }
    // this.updateInspection(true);
    // this.setTireStorageInfoTooltip()
  }

  highlighedItemType(text: string, query: string, partsOrderingType: string = '') {
    const label = text;
    if (label && query) {
      let str = label.replace(/\s/g, '&nbsp;');
      //to avoid showing $ replacing with paranthesis in the text with the html code ALP-20391
      str = str.replace(/\(/g, '&#40;');
      str = str.replace(/\)/g, '&#41;');

      const regex = new RegExp(escapeRegExp(`(${query.replace(/\s/g, '&nbsp;')})`), 'ig');
      str = str.replace(regex, `<span class="font-600"><b>$1</b></span>`);
      if (partsOrderingType) {
        str = `${str}<img src="${this.partsOrderingIcons[partsOrderingType]}" alt="">`;
      }
      return str;
    }

    return label || '';
  }

  deleteItem() {
    this.itemDelete.emit(this.index);
    this.calculatePrice();
  }

  handleDeleteItem(isConfirmationNeed: boolean = true, type: string = 'delete') {
    if (this.isArchivedRO || this.isFinalizedRo || (this.serviceItem?.type === 'hazmatFee' && this.serviceItem?.isPassThroughFet)) {
      return;
    }
    let heading = `Delete ${this.serviceItem.title}`;
    let message = `Are you sure you want to delete this ${this.serviceItem.type}?`;

    if (type === 'disassociate') {
      heading = `Disassociate ${this.serviceItem.title}`;
      message = `Disassociating this line from the Service would also discard any edits made to this line. Are you sure you want to continue?`;
    }

    if (isConfirmationNeed) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '30%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          styleClassHeading: 'font-14',
          title: heading,
          message: message,
          button: {
            success: { title: 'Delete', backgroundColor: '#d47877' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          this.dataService.sendData(this.dataService.typePassData('service-item-deleting', {}));
          this.itemDelete.emit(this.index);
          this.calculatePrice();
        }

        onClose.unsubscribe();
      });
    } else {
      this.dataService.sendData(this.dataService.typePassData('service-item-deleting', {}));
      this.itemDelete.emit(this.index);
      this.calculatePrice();
    }
  }

  showSuggestions(type?: string) {
    this.focus[type] = true;
    if (type === 'tireStorage') {
      if (this.customerId) {
        this.hideAddToStorage = true;
        if (this.isTireStorage2Enabled) this.searchSuggestion(this.searchQuery, this.type);
        else this.searchSuggestion('', this.type);
      }
    }
  }

  searchSuggestion(query: string, type?: string) {
    this.searchQuery = query;
    if (query) {
      this.hideAddToStorage = false;
    }
    if (type === 'partLookUp') {
      if (query) {
        query = query.toLowerCase();

        this.itemResults = this.partsLookupDropDownList.filter((item) => item.name.toLowerCase().includes(query));
      }
    }
    //else if(type === 'tireStorage' && this.isTireStorage2Enabled){
    //this.isSearching = true;
    //this.setTireStorageTemplate(query.trim());
    //}
    else if (['', 'part', 'labor', 'tire', 'hazmatFee', 'tireStorage', 'discount', 'bundle'].includes(type)) {
      this.isSearching = true;
      let motorQuery = '';
      let vehicleAge = 0;
      if (this.motorVehicle) {
        const { CountryID, EngineID, SubModelID, BaseVehicleID, Year } = this.motorVehicle;
        motorQuery = `vehicleBaseId=${BaseVehicleID}&EN=${EngineID}&CO=${CountryID}&SM=${SubModelID}`;
        vehicleAge = new Date().getFullYear() - Year;
      }

      // const searchtype = type === 'tireStorage' && this.isTireStorage2Enabled ? 'tireStorageTemplate' : type;
      //adding the tire storage for the backward compaitbility data
      if (type === 'tireStorage' && this.isTireStorage2Enabled) {
        if(this.dataService.isSalesCodeEnabled && !Object.keys(this.tireStorageV2Category || {})?.length) {
          this.getAllTireStorageCategories();
        }
      }
      this.httpService
        .getItems({
          type,
          limit: this.hideAddToStorage && this.isTireStorage2Enabled && type !== 'tireStorage' ? 5 : 100,
          motorQuery,
          search: type === 'tireStorage' && this.isTireStorage2Enabled ? '' : query.trim(),
          searchInMotor: true,
          appliedStatus: 'service',
          vehicleId: this.vehicleId,
          estimateId: this.estimateId,
          customerId: this.customerId,
        })
        .then(
          (data: any) => {
            this.itemResults = [];

            if (data.records) {
              data.records = data.records.map((item: any) => {
                if (item.type === 'part' || item.type === 'tire') {
                  item.cost = this.formatService.setDynamicCostAndPrice(item, 'cost');
                  item.price = this.formatService.setDynamicCostAndPrice(item, 'price');
                }

                if (this.customFleetSettings) {
                  const { isLaborRateOverride, isPricingMatrixOverride, customLaborRate, customPartPricingMatrix } = this.customFleetSettings;

                  if (item.type === 'labor' && isLaborRateOverride && customLaborRate) {
                    item.billRate = customLaborRate && customLaborRate.rate;
                    item.price = item.billRate * item.billableHours;
                    item.pricing = { pricingId: customLaborRate.pricingId, name: customLaborRate.name };
                  }

                  if (['part', 'tire'].includes(item.type)) {
                    if (isPricingMatrixOverride && customPartPricingMatrix) {
                      item.pricing = { pricingId: customPartPricingMatrix.pricingId, name: customPartPricingMatrix.name };
                      item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, customPartPricingMatrix);
                    }
                  }

                  if (item.type === 'part') {
                    if (this.companyLocalization) {
                      item.itemTitleFR = [item.titleFR || '', item.code || ''].filter((str) => str).join(' - ');
                      item.itemTitle = [item.title || '', item.code || ''].filter((str) => str).join(' - ');
                    } else {
                      item.itemTitle = [item.title || '', item.code || ''].filter((str) => str).join(' - ');
                    }
                  }
                }
                // if Advance Pricing then we need to check for Custom override other wise asssign the Fleet over ride
                if (this.isAttributeBasedPricingEnable) {
                  this.setAdvancePricing(item);
                }
                return item;
              });

              if (this.companyLocalization) {
                this.itemResults = data.records
                  .map((item: any) => {
                    if (
                      (item.titleFR && item.titleFR.toLowerCase().includes(query.trim().toLowerCase())) ||
                      (item.descriptionFR && item.descriptionFR.toLowerCase().includes(query.trim().toLowerCase()))
                    ) {
                        item.searchBy = 'titleFR';
                    } else {
                        item.searchBy = 'title';
                    }
                    return item;
                  })
                  .filter((item: any) => item.title || item.titleFR);
              } else {
                this.itemResults = data.records;
              }
              this.primarySuggestions = [...data.records];
            }

            if (data.isTireStorageEnabled && data.secondarySuggestions && data.secondarySuggestions.records) {
              let index = this.itemResults.length;

              const secondaryResults = data.secondarySuggestions.records.map((result: any) => {
                result.index = index;
                index++;
                result.cost = 0;
                result.price = 0;
                return result;
              });

              this.itemResults = [...this.itemResults, ...secondaryResults];
              this.secondarySuggestions = [{ items: secondaryResults }];
            }

            if (data.motorEnabled && data.secondarySuggestions?.Applications) {
              const motorResults = {
                '0': {
                  name: 'All',
                  items: [],
                },
              };

              data.secondarySuggestions.Applications.forEach(({ DisplayName, Items, IsActive, Taxonomy, ApplicationID, Position, Qualifiers, AttributeMappings }) => {
                let qualifiers = Qualifiers.filter(({ IsActive }) => IsActive !== false);
                if (!IsActive) {
                  return;
                }

                let notes = '',
                  laborType = '',
                  timedescription = '',
                  time = 0;

                if (Items?.length) {
                  Items.forEach(({ Notes, BaseLaborTime, LaborTimeInterval, RequiredSkill, BaseLaborTimeDescription }) => {
                    if (new RegExp(/Hours/, 'i').test(LaborTimeInterval)) {
                      time += Number(BaseLaborTime);
                    }

                    timedescription = BaseLaborTimeDescription;

                    if (RequiredSkill) {
                      laborType = RequiredSkill.Name;
                    }

                    if (Notes && Notes.length) {
                      Notes.forEach(({ Text }) => {
                        notes += Text;
                      });
                    }
                  });
                }

                const laborItem: any = {
                  cost: 0,
                  price: 0,
                  laborType,
                  subTotal: 0,
                  billRate: 0,
                  count: time,
                  actualLaborTime: time,
                  _id: 'no-id',
                  status: true,
                  type: 'labor',
                  title: DisplayName,
                  description: notes,
                  itemSource: 'Motor',
                  billableHours: time,
                  costEstimatedHours: time,
                  itemSourceId: ApplicationID,
                  qboId: this.itemSettings.labor.qboId,
                  isTaxable: this.itemSettings.labor.isTaxable,
                  commissionable: this.itemSettings.labor.commissionable,
                  displayHoursOnOrder: this.itemSettings.labor.displayHoursOnOrder,
                  displayDescOnOrder: this.itemSettings.labor.displayDescOnOrder,
                  tags: [],
                  isMotorLineItem: true,
                };
                const { motorLaborTimeMatrix } = this.itemSettings;

                if (motorLaborTimeMatrix?._id) {
                  const { value, markup } = this.calculationService.calculateLaborMarkupTime(vehicleAge, laborItem.actualLaborTime, motorLaborTimeMatrix);

                  laborItem.count = value;
                  laborItem.billableHours = value;
                  laborItem.motorMarkup = markup;
                }

                laborItem.title = this.helperService.makeMotorServiceName(DisplayName, Position, timedescription, qualifiers, AttributeMappings, data.secondarySuggestions.Attributes, 'labor');

                const motorTag = find(this.serviceTags, {
                  type: 'service_tag',
                  name: 'MOTOR',
                });

                if (motorTag) {
                  laborItem.tags.push(motorTag);
                }

                if (this.skillType.indexOf(laborType) !== -1) {
                  if (this.motorLaborPricing[laborType]) {
                    const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;

                    let billRate = this.motorLaborPricing[laborType].price;
                    let pricing = this.motorLaborPricing[laborType].pricing;

                    if (isLaborRateOverride && customLaborRate) {
                      billRate = customLaborRate && customLaborRate.rate;
                      pricing = customLaborRate;
                    }

                    laborItem.cost = this.motorLaborPricing[laborType].cost * laborItem.costEstimatedHours;
                    laborItem.billRate = billRate;
                    laborItem.price = laborItem.billRate;
                    laborItem.subTotal = laborItem.billRate * laborItem.count;
                    laborItem.pricing = pricing;
                  }
                } else {
                  if (this.motorLaborPricing.General) {
                    const { isLaborRateOverride, customLaborRate } = this.customFleetSettings;

                    let billRate = this.motorLaborPricing.General.price;
                    let pricing = this.motorLaborPricing.General.pricing;

                    if (isLaborRateOverride && customLaborRate) {
                      billRate = customLaborRate && customLaborRate.rate;
                      pricing = customLaborRate;
                    }

                    laborItem.cost = this.motorLaborPricing.General.cost * laborItem.costEstimatedHours;
                    laborItem.billRate = billRate;
                    laborItem.price = laborItem.billRate;
                    laborItem.subTotal = laborItem.billRate * laborItem.count;
                    laborItem.pricing = pricing;
                  }
                }

                if (Taxonomy) {
                  laborItem.category = {
                    name: [Taxonomy?.SystemName, Taxonomy?.GroupName, Taxonomy?.SubGroupName].filter((str) => str).join(' '),
                    category: {
                      categoryId: Taxonomy?.SystemID || '',
                      categoryName: Taxonomy?.SystemName || '',
                    },
                    subCategory: {
                      subCategoryId: Taxonomy?.GroupID || '',
                      subCategoryName: Taxonomy?.GroupName || '',
                    },
                    subSubCategory: {
                      subSubCategoryId: Taxonomy?.SubGroupID || '',
                      subSubCategoryName: Taxonomy?.SubGroupName || '',
                    },
                  };
                }

                if (Taxonomy?.GroupName) {
                  if (motorResults[Taxonomy.GroupName]) {
                    motorResults[Taxonomy.GroupName].items.push(laborItem);
                  } else {
                    motorResults[Taxonomy.GroupName] = {
                      name: Taxonomy.GroupName,
                      items: [laborItem],
                    };
                  }
                } else {
                  motorResults['0'].items.push(laborItem);
                }
              });

              let index = this.primarySuggestions.length;

              this.secondarySuggestions = Object.values(motorResults);
              this.secondarySuggestions.forEach(({ items }) => {
                items.forEach((item: any) => {
                  item.index = index;
                  index++;
                });
                this.itemResults = [...this.itemResults, ...items];
              });
            }

            this.hasDividedResults = data.motorEnabled || data.isTireStorageEnabled;

            this.cdr.detectChanges();
            this.toTop();
          },
          (err) => {
            this.isSearching = false;
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          if (type === 'tireStorage' && this.isTireStorage2Enabled) {
            if (this.isTireStorage2Enabled && type === 'tireStorage') {
              this.tireStorageV2OutData = this.helperService.deepCopy(this.itemResults);
            }
            // && trim(query)
            if (type === 'tireStorage' && this.isTireStorage2Enabled) {
              // this.isSearching = true;
              const tsQuery = trim(query) || trim(this.searchQuery);
              this.setTireStorageTemplate(tsQuery);
              return;
            }
          } else this.isSearching = false;
        });
    }
  }

  setAdvancePricing(item: any) {
    const overRide = item.type === 'part' ? this.partOverRideToApply : this.tireOverRideToApply;
    const rule = item.type === 'part' ? this.partPricingRule : this.tirePricingRule;
    if (overRide?.name) {
      let matrix;
      // check for catgeory override
      const categoryId = item.type === 'tire' ? this.makeCategoryId(item?.category?._id, item?.brandId) : item?.category?._id;
      if (categoryId) {
        const overrideExist = overRide?.category?.find((c) => {
          const overrideCategoryId = item.type === 'tire' ? this.makeCategoryId(c?._id, c?.brand?.id) : c._id;
          return overrideCategoryId === categoryId;
        });
        if (overrideExist) {
          matrix = overrideExist.matrix;
        } else {
          matrix = overRide.defaultMatrix;
        }
      } else {
        matrix = overRide.defaultMatrix;
      }
      let matrixInfo = this.helperService.deepCopy(
        this.pricingList.find((m) => {
          return m._id === matrix.id;
        }),
      );

      item.pricing = { pricingId: matrix.id, name: matrix.name, pricingRuleId: rule._id };
      if(matrixInfo) {
        item.pricing.name = `${rule.name} Override (${matrixInfo.name})`;
        if (item.type !== 'hazmatFee' && item.isPassThroughTax) {
          item.price = this.calculationService.calculateMarkUpUsingPricing(item.cost, matrixInfo);
        }
      }
      
    }
  }
  makeCategoryId(categoryId, brandId) {
    let id = '';
    if (categoryId) id = categoryId;
    if (id.length && brandId) id += `-${brandId}`;
    if (id.length === 0 && brandId) id = brandId;
    return id;
  }
  fetchAndSelectAttachedItems({ itemId, itemInternalReference, isAddItemNeeded = true, isAdding = false }) {
    this.addAssociatedItems.emit({ itemId, itemInternalReference, isAddItemNeeded, isAdding });
  }

  handleDropdownSelect = (type: string, data: any) => {
    if (type === 'type') {
      // if (data.value === 'partLookUp') {
      //   this.serviceItem.typeHasPartLookup = true;
      // } else {
      //   this.serviceItem.typeHasPartLookup = false;
      // }
      if (this.serviceItem.itemId) {
        return;
      }

      this.type = data.value;
      this.serviceItem.type = data.value;
      this.selectedType = { ...data };
      this.serviceItem.title = '';
      this.serviceItem.description = '';
      delete this.serviceItem.itemId;
      delete this.serviceItem._id;
      this.itemResults = [];
      this.serviceItem.subTotal = 0;

      if (this.type === 'other') {
        this.focus.title = true;
      } else {
        this.focus.titleSearch = true;
      }

      if (['part', 'tire'].includes(data.value) && ['PartsTech', 'Nexpart'].includes(data.partsOrderingType)) {
        this.appHandleOnlinOrderAction.emit({
          source: data.partsOrderingType,
          serviceId: this.serviceId,
          actionType: 'open-parts-ordering-cart',
        });
        return;
      }

      if (this.type === 'part') {
        this.serviceItem.title = '';
        this.serviceItem.price = '';
        this.serviceItem.count = this.serviceItem.count ? parseInt(this.serviceItem.count, 10) : '';
        this.calculatePrice();
      } else if (this.type === 'hazmatFee') {
        this.serviceItem.title = '';
        this.serviceItem.price = '';
        this.serviceItem.count = this.serviceItem.count ? parseInt(this.serviceItem.count, 10) : '';
        this.calculatePrice();
      } else if (this.type === 'labor') {
        this.serviceItem.price = '';
        this.serviceItem.count = data.billableHours;
        this.calculatePrice();
      } else if (this.type === 'tire') {
        this.serviceItem.price = '';
        this.serviceItem.count = this.serviceItem.count;
        this.calculatePrice();
      } else if (this.type === 'tireStorage') {
        this.serviceItem.price = '';
        this.serviceItem.count = '';
        this.calculatePrice();
        //if(this.isTireStorage2Enabled) this.setTireStorageTemplate();
      } else if (this.type === 'other') {
        this.serviceItem.isTaxable = this.isOtherTaxable;

        if (!this.serviceItem.count) {
          this.serviceItem.count = 1;
          this.calculatePrice();
        }
        this.focus.title = true;
      } else if (this.type === 'sublet') {
        this.serviceItem.isTaxable = this.isSubletTaxable || false;

        if (!this.serviceItem.count) {
          this.serviceItem.count = 1;
          this.calculatePrice();
        }
        this.focus.title = true;
      } else if (this.type == 'partLookUp') {
        this.serviceItem.title = '';
        this.itemResults = this.partsLookupDropDownList;
        this.focus.title = true;
      }
    } else if (type === 'price') {
      this.serviceItem.price = data.rate;
      this.serviceItem.count = 1;
      this.calculatePrice();
    } else if (type === 'isTaxable') {
      this.serviceItem.isTaxable = data.value;
      this.calculatePrice();
    }

    if (!this.isNewServiceAdded) {
      this.addServiceItem.emit({});
      this.isNewServiceAdded = true;
    }

    this.focus[type] = false;
    if (type !== 'tireStorage' || !this.isTireStorage2Enabled) this.saveServiceItem();
  };

  onTagDelete(tags: any[]) {
    this.serviceItem.tags = tags;
    this.saveServiceItem();
  }

  onTagCreate(tag: any) {
    this.appTagCreated.emit(tag);
  }

  onTagSelect(event: any) {
    event.default = false;
    if (event._id) {
      event.tagId = event._id;
    }
    // preventing deleting tags for sublet.
    // if(this.serviceItem.type === 'sublet' && ['Sublet', 'Supplier assigned', 'Supplier unassigned'].includes(event.name)) {
    //   event.default = true;
    // }
    const exists = this.serviceItem.tags.some(tag => tag.name === event.name);
    if (!exists) {
      this.serviceItem.tags.push(event);
    }
    this.saveServiceItem();
  }

  async createTireStorage(data: any, close?: any) {
    if (this.serviceItem.type === 'tireStorage') {
      const tire: any = {
        brand: data.brand,
        category: data.category,
        code: data.code,
        cost: data.cost,
        count: data.count,
        displayDescOnOrder: data.displayDescOnOrder,
        displayHoursOnOrder: data.displayHoursOnOrder,
        isTaxable: data.isTaxable,
        commissionable: data.commissionable,
        model: data.model,
        price: data.price,
        pricing: data.pricing,
        seasonality: data.seasonality,
        size: data.size,
        status: data.status,
        supplier: data.supplier,
        title: data.title,
        type: 'tireStorage',
        tiresInfo: [],
        storageRO: { orderId: this.estimateId },
      };

      for (let i = 0; i < data.count; i++) {
        tire.tiresInfo.push({});
      }

      if (close) {
        close();
      }
      tire.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
      const tireStorage = await this.httpService.createTireStorage(tire);
      const storeTag = find(this.serviceTags, { name: 'Store' });
      delete tireStorage.tireStorageStatus;

      if (storeTag) {
        // tireStorage.tags = [{ ...storeTag, tagId: storeTag._id }];
      }

      if (this.dataService.isSalesCodeEnabled) {
        tireStorage.tags = this.helperService.updateClassficationServiceItemTag(tireStorage.tags, tireStorage);
      }
      this.handleSelect('tireStorage', tireStorage);
    }
  }

  getServiceItemTitle() {
    let title = '';
    if (this.isTireStorage2Enabled && this.serviceItem.type === 'tireStorage' && (this.serviceItem.title || this.serviceItem.titleFR)) {
      title =
        this.companyLocalization && this.currentLang === 'fr' && this.serviceItem.titleFR ? this.serviceItem.titleFR || this.serviceItem.title : this.serviceItem.title || this.serviceItem.titleFR;
      if (!this.serviceItem?.tireStorageStatus || ['remove', 'store'].includes(this.serviceItem.tireStorageStatus)) title = `Tires In - ${title}`;
      else if (this.serviceItem.tireStorageStatus === 'return') title = 'Tires Out';
    } else {
      title =
        this.companyLocalization && this.currentLang === 'fr' && this.serviceItem.titleFR ? this.serviceItem.titleFR || this.serviceItem.title : this.serviceItem.title || this.serviceItem.titleFR;
    }
    return title;
  }
//adding the tire storage for the backward compaitbility data
  getAllTireStorageCategories() {
    const query: any = { itemType: 'tireStorage' };
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        if (res?.categories && res?.categories?.length) {
          this.tireStorageV2Category = res.categories[0];
        }
      });
  }

  async handleSelect(type: string, data: any, close?: any, isAddItemNeeded: boolean = true, serviceItem?: any, cardIndex?: any, index?: any) {
    if (data.type === 'labor' && !data.status) return;

    if (this.isTireStorage2Enabled && data.type === 'tireStorageTemplate' && Object.keys(data?.associatedInspection || {})?.length && Object.keys(this.serviceInspection || {})?.length) {
      if (this.serviceInspection.isTireStorageInspection) {
        this.helperService.showToaster('error', 'You can only store one set of tires per service. A tire in item is already added to service.');
      } else {
        this.helperService.showToaster('error', `Inspection already exists! Add 'Tires In' to another service.`);
      }
      return;
    }

    if (this.isTireStorage2Enabled && !type && data.type === 'tireStorageTemplate') {
      type = 'tireStorage';
      const obj = find(this.itemTypeOptions, { value: type });
      this.type = obj.value;
      this.serviceItem.type = obj.value;
      this.selectedType = { ...obj };
    }

    if (!this.invoiceType && data.type === 'discount') {
      const isNegative = this.isBalanceNegative({ data, serviceId: this.serviceId, itemType: 'service', actionType: 'create' });

      if (isNegative) {
        this.handleNegativeDiscountPrompt(type, data);
        if (close) close();
        return;
      }
    }
    if (data.type === 'partLookUp' && !data._id) {
      data._id = await this.httpService.getObjectId();
    }

    if (data.type === 'bundle' && isAddItemNeeded) {
      this.appGetAndSelectBundleItem.emit({ itemId: data._id, index: this.index });
      return;
    }

    const saveServicePayload = { replaceService: false, isOpenFromUpdateSupplier: false };

    if (type === 'tireStorage' && this.isTireStorage2Enabled && !data?.isTireOut) {
      this.serviceItem.title = data.title;
      this.serviceItem.titleFR = data.titleFR;
      if (this.companyLocalization && this.currentLang === 'fr' && data.titleFR) {
        this.defaultTitle = data.titleFR;
      } else {
        this.defaultTitle = data.title;
      }

      this.serviceItem.price = data.type === 'labor' ? data.billRate : data.price;
      this.serviceItem.cost = data.cost;
      this.serviceItem.count = data.count;
      this.serviceItem.originalCount = data.count;
      this.serviceItem.originalCost = data.cost;
      this.serviceItem.originalPrice = data.price;
      this.serviceItem.commissionable = data.commissionable;
      this.serviceItem.displayDescOnOrder = data.displayDescOnOrder;
      this.serviceItem.displayHoursOnOrder = data.displayHoursOnOrder;
      this.serviceItem.itemSource = data.itemSource || '';
      this.serviceItem.type = 'tireStorage';
      (this.serviceItem.tireStorageStatus = ''), (this.serviceItem.tireStorageTemplateId = data._id);
      this.serviceItem.isTaxable = data.isTaxable;
      this.serviceItem.status = data.status;
      this.serviceItem.salesCode = data.salesCode || {};
      this.serviceItem.category = data.category;
      this.serviceItem.pricingType = data.pricingType;
      this.serviceItem.associatedInspection = data.associatedInspection;
      this.serviceItem.internalNotes = data.internalNotes;
      this.serviceItem.itemId = ' ';

      if (data.pricingType === 'flatFee') {
        this.serviceItem.mockFlatPrice = data.price;
        this.serviceItem.mockFlatCost = data.cost;
        this.serviceItem.price = data.price / data.count;
        this.serviceItem.cost = data.cost / data.count;
      }

      // this.tireStorageCount = this.serviceItem.count;
      if (this.dataService.isSalesCodeEnabled) {
        //adding the tire storage for the backward compaitbility data
        if(!Object.keys(this.serviceItem?.salesCode)?.length) {
          if(this.tireStorageV2Category?.salesCode && this.tireStorageV2Category?.salesCode?.salesCodeId) {
            this.serviceItem.salesCode = this.tireStorageV2Category?.salesCode;
          }
        }
        this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
      }

      const tire: any = {
        brand: data.brand || '',
        code: data.code,
        cost: data.cost,
        count: data.count,
        displayDescOnOrder: data.displayDescOnOrder,
        displayHoursOnOrder: data.displayHoursOnOrder,
        isTaxable: data.isTaxable,
        commissionable: data.commissionable,
        model: data.model || '',
        price: data.price,
        seasonality: data.seasonality || '',
        size: data.size || '',
        status: data.status,
        title: data.title,
        type: 'tireStorage',
        tireStorageStatus: '',
        tireStorageTemplateId: data._id,
        tiresInfo: [],
        storageRO: { orderId: this.estimateId },
      };

      if (this.dataService.isSalesCodeEnabled) tire.salesCode = data.salesCode || {};

      tire.isSalesCodeEnabled = this.dataService.isSalesCodeEnabled;
      if (data.associatedInspection) tire.associatedInspection = data.associatedInspection;
      const tireStorage = await this.httpService.createTireStorage(tire);
      if (tireStorage?._id) {
        this.serviceItem.itemId = tireStorage._id;
        this.setTireStorageInfoTooltip(true);
        this.defaultService = this.helperService.deepCopy(this.serviceItem);
        if (this.serviceItem.associatedInspection && this.serviceItem.associatedInspection?.inspectionId) {
          const conf = {
            inspectionId: this.serviceItem.associatedInspection.inspectionId,
            serviceId: this.serviceId,
            estimateId: this.estimateId,
            tireCount: this.serviceItem.count,
          };
          this.httpService.createStorageInspection(conf).then(
            (res: any) => {
              // this.saveServiceItem(saveServicePayload);
              this.dataService.sendData(
                this.dataService.typePassData('update-service-inspection', {
                  status: true,
                  value: {
                    inspection: res.inspection,
                    serviceId: this.serviceId,
                  },
                }),
              );
              this.cdr.detectChanges();
            },
            (error) => {
              this.saveServiceItem(saveServicePayload);
              this.helperService.showToaster('error', error);
            },
          );
        } else {
          this.saveServiceItem(saveServicePayload);
        }
      }
      this.focus[type] = false;
      this.setItemsActionOption();
    } else if (['part', 'labor', 'tire', 'hazmatFee', 'tireStorage', 'discount', 'bundle', 'partLookUp'].includes(type) || !type) {
      this.serviceItem.title = data.title;
      this.serviceItem.titleFR = data.titleFR;
      if (this.companyLocalization && this.currentLang === 'fr' && data.titleFR) {
        this.defaultTitle = data.titleFR;
      } else {
        this.defaultTitle = data.title;
      }
      this.serviceItem.itemInternalReference = `${this.serviceId}-${this.uniqueInternalReferenceCount.count++}`;
      this.serviceItem.itemId = data?._id;
      this.serviceItem.partTypeId = data?.partTerminologyID || '';
      this.serviceItem.price = data.type === 'labor' ? data.billRate : data.price;
      this.serviceItem.cost = data.cost;
      this.serviceItem.invalid = false;
      this.serviceItem.description = data?.description;
      this.serviceItem.internalNotes = data?.internalNotes || '';
      this.serviceItem.descriptionFR = data.descriptionFR;
      this.serviceItem.itemSourceId = data.itemSourceId;
      this.serviceItem.commissionable = data.commissionable;
      this.serviceItem.lineCartId = data.lineCartId;
      this.serviceItem.orderItemId = data.orderItemId;
      this.serviceItem.partOrderId = data.partOrderId;
      this.serviceItem.actualLaborTime = data.actualLaborTime;
      this.serviceItem.displayDescOnOrder = data.displayDescOnOrder;
      this.serviceItem.displayHoursOnOrder = data.displayHoursOnOrder;
      this.serviceItem.itemSource = data.itemSource || '';
      this.serviceItem.imgUrl = data.imgUrl || '';
      this.serviceItem.type = data.type;
      this.serviceItem.supplier = data.supplier;
      this.serviceItem.costEstimatedHours = data.costEstimatedHours;
      this.serviceItem.isTaxable = data.isTaxable;
      this.serviceItem.code = data.code;
      this.serviceItem.stocked = data.stocked;
      this.serviceItem.category = data.category;
      this.serviceItem.model = data.model;
      this.serviceItem.size = data.size;

      this.serviceItem.tireSize = data.tireSize;
      this.serviceItem.tireProfile = data.tireProfile;
      this.serviceItem.tireWidth = data.tireWidth;

      this.serviceItem.isFlatRateSubItem = data.isFlatRateSubItem;
      this.serviceItem.flatRateId = data.flatRateId;
      this.serviceItem.associatedItemsInternalReferences = data.associatedItemsInternalReferences || [];
      this.serviceItem.seasonality = data.seasonality;
      // this.serviceItem.isFlatRateSubItem = false;
      this.serviceItem.locationQboItemRefId = data.locationQboItemRefId || {};
      this.serviceItem.qboItemRefId = data.qboItemRefId || '';
      this.serviceItem.qboId = data.qboId || '';
      this.serviceItem.salesCode = data.salesCode || {};
      if (data.locations?.length && this.dataService.warehouse && this.dataService.warehouse.warehouseId) {
        const selectedLocation = data.locations.find((location) => location.warehouseId === this.dataService.warehouse.warehouseId);
        if (selectedLocation) {
          this.serviceItem.locations = [selectedLocation];
        } else {
          //In case of single location tennant warehouse does not exists in that case location must be assigned as a part of fix - ALP-19136
          this.serviceItem.locations = data.locations[0];
        }

      } else {
        //In case of single location tennant warehouse does not exists in that case location must be assigned as a part of fix - ALP-19136
        if (data.locations?.length) {
          this.serviceItem.locations = data.locations[0];
        }
      }

      const shopDetails = find(data?.shopDetails || [], { shopId: this.helperService.getCurrentShopId() });

      if (type === 'tire') {
        this.serviceItem.priceOnPO = this.serviceItem.price;
      }

      if (!this.dataService.isAttributeBasedPricingEnable && shopDetails && Object.keys(shopDetails?.pricing || {})?.length && !(this.customFleetSettings && (this.customFleetSettings?.isPricingMatrixOverride || this.customFleetSettings?.isPricingMatrixOverride?.isLaborRateOverride))) {
        // for advance pricing we want to use the pricing from the item it self
        this.serviceItem.pricing = shopDetails?.pricing;
      } else {
        this.serviceItem.pricing = data.pricing;
      }

      if (data?.tireType?.name) {
        this.serviceItem.tireType = data?.tireType;
      }

      if (
        (this.dataService.isSalesCodeEnabled || this.dataService.isPartWarrantiesEnabled) &&
        this.serviceItem.type !== 'bundle') {
        if (data.isMotorLineItem) {
          this.httpService
            .getCategoryByQuery({
              source: 'motor',
              itemType: 'labor',
              categoryId: data.category?.category?.categoryId,
              categoryName: encodeURIComponent(data.category?.category?.categoryName),
              subCategoryId: data.category?.subCategory?.subCategoryId,
              subCategoryName: encodeURIComponent(data.category?.subCategory?.subCategoryName),
              subSubCategoryId: data.category?.subSubCategory?.subSubCategoryId,
              subSubCategoryName: encodeURIComponent(data.category?.subSubCategory?.subSubCategoryName),
            })
            .then((data) => {
              if(this.dataService.isSalesCodeEnabled) {
                this.serviceItem.salesCode = this.helperService.assignSalesCode(data);
              }

              if (this.serviceItem.category?._id) {
                this.serviceItem.category._id = data._id;
              }
              if (this.serviceItem.category) {
                this.serviceItem.category = {
                  categoryId: data._id,
                  categoryName: this.serviceItem?.category?.category?.categoryName,
                  subCategoryId: this.serviceItem?.category?.subCategory?.subCategoryId,
                  subCategoryName: this.serviceItem?.category?.subCategory?.subCategoryName,
                  subSubCategoryId: this.serviceItem?.category?.subSubCategory?.subSubCategoryId,
                  subSubCategoryName: this.serviceItem?.category?.subSubCategory?.subSubCategoryName,
                };
              }
              if(this.dataService.isSalesCodeEnabled) {
                this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
              }

            });
        } else {
          if(this.dataService.isSalesCodeEnabled) {
            //adding the tire storage for the backward compaitbility data
            if(!Object.keys(this.serviceItem?.salesCode)?.length &&  this.serviceItem.type === 'tireStorage') {
              if(this.tireStorageV2Category?.salesCode && this.tireStorageV2Category?.salesCode?.salesCodeId) {
                this.serviceItem.salesCode = this.tireStorageV2Category?.salesCode;
              }
            }
            this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
          }

        }
      }

      // FET fee value in case of tire
      if (['tire'].includes(type || data?.type) && this.dataService.isPassThroughTaxEnable) {
        this.serviceItem.fetValue = data?.fetValue || 0;
      }

      this.serviceItem.coreCost = data.coreCost;
      this.serviceItem.totalCoreCost = data.totalCoreCost || data.coreCost;
      this.serviceItem.seasonality = data.seasonality;
      this.serviceItem.hasCore = data.hasCore || false;
      this.serviceItem.hasReturn = data.hasReturn || false;
      this.serviceItem.associatedItems = data.associatedItems || [];
      this.serviceItem.cost = this.formatService.setDynamicCostAndPrice(this.serviceItem, 'cost');
      this.serviceItem.price = this.formatService.setDynamicCostAndPrice(this.serviceItem, 'price');

      if (data.type === 'labor') {
        if (this.isOverrideCostWithTechRate && this.serviceItem.avgTechCost > 0) {
          this.serviceItem.cost = this.serviceItem.avgTechCost * this.serviceItem.costEstimatedHours;
        }

        this.serviceItem.count = data.billableHours;
      } else {
        this.serviceItem.count = data.count;
      }

      this.selectedType = {
        value: data.type,
        label: this.labels[data.type],
      };

      this.focus.notes = isAddItemNeeded;

      if (data.type === 'bundle') {
        this.serviceItem.netPrice = data.netPrice;
        this.serviceItem.subTotal = data?.subTotal || data?.flatRate;
        this.serviceItem.netSubTotal = this.serviceItem.subTotal;
        this.serviceItem.flatRateId = data.flatRateId;
        this.serviceItem.isFlatRateSubItem = data.isFlatRateSubItem;
        this.serviceItem.subItems = data.subItems;

        if (this.dataService.isSalesCodeEnabled) {
          this.serviceItem.subItems.forEach((subItem: any) => {
            subItem.tags = this.helperService.updateClassficationServiceItemTag(subItem.tags || [], subItem);
          });
        }
        this.serviceItem.subItems.forEach((subItem: any) => {
          if (subItem.type === 'partLookUp') {
            this.postPartLookupSelectedEvent('Flat rate', subItem.title);
          }

          subItem.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
          subItem.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
        });
      }

      if (data.type === 'hazmatFee') {
        this.serviceItem.feeValueType = data.feeValueType || 'fixed';

        if (data?.isPassThroughFet) {
          this.serviceItem.isPassThroughFet = data?.isPassThroughFet;
        }

        this.serviceItem.isPassThroughTax = data.isPassThroughTax ? data.isPassThroughTax : false;

        if (this.serviceItem.feeValueType === 'percent') {
          this.serviceItem.pricePercent = data.autoAdded ? data.pricePercent : data.price;
          this.serviceItem.costPercent = data.autoAdded ? data.costPercent : data.cost;
        }
      }

      if (data.type === 'discount') {
        this.serviceItem.discountType = data.discountType;
        this.serviceItem.discountCap = data.discountCap;
        this.serviceItem.discountValue = data.discountValue;

        if (this.serviceItem.discountType === 'percentage') {
          this.serviceItem.price = 0;
        } else {
          this.serviceItem.price = data.discountValue;
        }
      }

      if (data.type === 'tireStorage') {
        //Adding the check case of tire storage against ALP-20103, do not revert it back in case of tire out of tirestorage status
        if(this.isTireStorage2Enabled && data.isTireOut) {
          this.serviceItem.tireStorageStatus = 'return';
        } else {
          this.serviceItem.tireStorageStatus = data.tireStorageStatus === 'store' ? 'return' : 'store';
        }
        
        if (!data.tags) {
          if (this.serviceItem.tags?.length) {
            data.tags = this.serviceItem.tags;
          } else {
            data.tags = [];
          }
        }

        if(!this.isTireStorage2Enabled) {
          if (this.serviceItem.tireStorageStatus === 'store') {
            const tag = find(this.serviceTags, { name: 'Store' });

            if (tag) {
              data.tags.push({ ...tag, tagId: tag._id });
            }
          } else {
            const tag = find(this.serviceTags, { name: 'Return' });

            if (tag) {
              data.tags.push({ ...tag, tagId: tag._id });
            }
          }
        }

        if (this.isTireStorage2Enabled && data.isTireOut) {
          this.serviceItem.cost = 0;
          this.serviceItem.price = 0;
          this.serviceItem.isInStorage = true;
          this.serviceItem.isTireStorageRemoved = true;
          this.serviceItem.isReturned = false;
          this.setTireStorageInfoTooltip(true)
          if(data.tiresInfo && !this.serviceItem.description) this.populateTireStorageDescription(data.tiresInfo)
        }
      }

      if (data.type === 'tire') {
        this.setDotNumberTooltip(this.serviceItem.dotNumbers);
        this.setDotNumberIcon();
      }

      if (['tire', 'tireStorage'].includes(data.type)) {
        if (data.brandId) {
          this.serviceItem.brand = {
            brandId: data.brandId,
            name: data.brand,
          };

          if (data.category?.categoryId) {
            this.serviceItem.category = data.category;
          }
        } else if (data?.category?.categoryId) {
          this.serviceItem.brand = {
            name: data.category.name,
          };

          if (this.serviceItem.category.categoryId?.length === 24) {
            this.serviceItem.brand.brandId = this.serviceItem.category.categoryId;
          }
        } else if (data.brand) {
          this.serviceItem.brand = {
            name: data.brand,
          };
        }
      }

      if (data.type === 'part' && data.hasCore) {
        const coreTag = find(this.serviceTags, { value: 'core' });

        saveServicePayload.replaceService = true;

        this.serviceItem.isCoreUpdatedRequired = true;
        this.serviceItem.coreRetrievalStatus = 'toBeRetrieved';
        this.serviceItem.tags.push({ ...coreTag, name: `Core: To be retrieved` });
        this.httpService.saveItemCoreCost({ ...this.serviceItem, orderId: this.estimateId, orderCode: this.estimateCode }).then(
          (res) => { },
          (err) => {
            console.log(err);
          },
        );
      }

      this.type = data.type;
      this.calculatePrice();

      if (data.qboId) {
        this.serviceItem.qboId = data.qboId;
      } else if (this.qboRefs[data.type]) {
        this.serviceItem.qboId = this.qboRefs[data.type];
      }

      if (data.tags) {
        this.serviceItem.tags = data.tags || [];
      }

      if (data && data.isOpenFromUpdateSupplier) {
        this.serviceItem.tags = [];
        saveServicePayload.isOpenFromUpdateSupplier = true;
      }
      this.setItemsActionOption();

      let text = `RO# ${this.estimateCode}: ${this.labels[data.type]} (${this.serviceItem.title || this.serviceItem?.titleFR}) of value\
        $${Number(this.serviceItem.subTotal).toFixed(2)} was added to the Service "${this.serviceTitle}"`;

      if (this.isAttributeBasedPricingEnable) {
        //Should not use the split funtion without checking existence.
        //let matrixName = data.whichPricingMatrixUsed.split(':')[1]
        //let markUp = data.whichPricingMatrixUsed.split(':')[2]
        let matrixName = '';
        let markUp = '';
        if (data.whichPricingMatrixUsed) {
          const matrixNameArray: any[] = data.whichPricingMatrixUsed.split(':');
          if (matrixNameArray?.length > 1) {
            matrixName = data.whichPricingMatrixUsed.split(':')[1];
          }

          if (matrixNameArray?.length > 2) {
            markUp = data.whichPricingMatrixUsed.split(':')[2];
          }
        }
        let appendedText = '';
        if (data.isPriceManuallyAdded) {
          appendedText = ', priced manually';
        } else if (data.pricing && data.pricing.name === 'Company Level') {
          appendedText = `priced with company rules, using ${matrixName} matrix at a markup of ${markUp}%`;
        } else if (data.pricing && data.pricing.name === 'location') {
          appendedText = `priced with location rules, using ${matrixName} matrix at a markup of ${markUp}%`;
        }
        text += appendedText;
      }
      this.generateActivity.emit({
        entityId: this.serviceId,
        entityType: 'service',
        entityAction: 'updated',
        isPrimary: false,
        activityData: { type: 'plaintext', icon: [this.icons[data.type]] },
        title: `${this.labels[data.type]} added`,
        text,
      });

      if (close) {
        close();
      }

      if (data.associatedItems && data.associatedItems.length) {
        if (data.type === 'hazmatFee') {
          const counts = this.countOfItemsExistsInFees({ associatedItems: data.associatedItems.map(({ itemId }) => itemId) });
          // added counts check as part of fixing ALP-8033
          if (data.feeValueType === 'percent' && counts.itemIds && counts.itemIds.length > 0) {
            this.serviceItem.price = this.calculationService.roundOff((counts.price * this.serviceItem.price) / 100);
            this.serviceItem.cost = this.calculationService.roundOff((counts.cost * this.serviceItem.cost) / 100);
          }

          if (counts.itemIds && counts.itemIds.length > 0) {
            this.serviceItem.count = counts.count;
            this.serviceItem.associatedItemsInternalReferences = counts.itemIds;
            this.serviceItem.associatedItems = counts.itemIds;
          }
        } else {
          isAddItemNeeded = false;
          this.fetchAndSelectAttachedItems({
            itemId: data._id,
            itemInternalReference: this.serviceItem.itemInternalReference,
            isAddItemNeeded: isAddItemNeeded,
            isAdding: true,
          });
        }
      }
    } else {
      if (this.qboRefs.other) {
        this.serviceItem.qboId = this.qboRefs.other;
      }
      this.serviceItem.isTaxable = true;
    }

    if (!this.isNewServiceAdded) {
      this.addServiceItem.emit({});
      this.isNewServiceAdded = true;
    }

    if (data?.partSpecification) {
      this.serviceItem.partSpecification = this.helperService.deepCopy(data?.partSpecification);
    }

    this.setTireExtraFields(data);
    // if(data?.brandId) {
    //   this.serviceItem.partSpecification = {
    //     brand: {
    //       id: data?.brandId,
    //       name: data?.brand
    //     }
    //   };

    //   if(data?.subBrandId) {
    //     this.serviceItem.partSpecification.productLine = {
    //       id: data?.subBrandId,
    //       name: data?.subBrand
    //     };
    //   }
    // }
    if (this.dataService.isPartWarrantiesEnabled) {
      if (['part', 'tire'].includes(data.type) && data?.isWarrantyEligible) {
        this.serviceItem.isWarrantyEligible = data?.isWarrantyEligible;
        this.serviceItem.warranty = {
          warrantySettingId: data?.warranty?.warrantySettingId,
          title: data?.warranty?.title,
        };
        this.openWarrantyEligibleDialog({
          itemTitle: this.serviceItem?.title || '',
          itemId: this.serviceItem.itemId,
          partNumber: this.serviceItem?.code || '',
          type: data.type,
        });
      } else if (data.type === 'bundle') {
        const eligibleItemsArray: any[] = this.getWarrantyEligibleSubItems(this.serviceItem);
        if (eligibleItemsArray?.length) {
          this.openWarrantyEligibleDialog({
            eligibleItems: eligibleItemsArray,
            vehicleId: this.vehicleId,
            customerId: this.customerId,
            isMultipleItemsView: true,
          });
        }
      }
    }

    this.focus[type] = false;
    if ((type === 'tireStorage' && this.isTireStorage2Enabled && this.serviceItem.tireStorageStatus === 'return') || type !== 'tireStorage' || !this.isTireStorage2Enabled)
      this.saveServiceItem(saveServicePayload);
    this.defaultService = this.helperService.deepCopy(this.serviceItem);
    if (data.type === 'partLookUp') {
      this.openDialog(serviceItem, cardIndex, index, false);
      this.postPartLookupSelectedEvent('RO', serviceItem.title);
    }
  }

  getWarrantyEligibleSubItems(item: any): any[] {
    let eligibleItems: any[] = [];
    if (item?.subItems?.length) {
      item?.subItems?.forEach((subItem: any) => {
        if (['part', 'tire'].includes(subItem.type) && subItem?.isWarrantyEligible) {
          const index = findIndex(subItem?.tags, { tagType: 'partWarranties' });
          if (index < 0) {
            if (!subItem?.tags?.length) {
              subItem.tags = [];
            }
            subItem.tags.push({
              color: '#3D7EAD',
              name: 'Warranty',
              tagType: 'partWarranties',
              tooltip: `Warranty`,
            });
          }
          const obj = {
            itemTitle: subItem.title || '',
            itemId: subItem.itemId,
            partNumber: subItem?.code || '',
            type: subItem.type,
            bundleId: item.itemId,
          };
          eligibleItems.push(obj);
        }
      });
    }

    return eligibleItems;
  }

  postPartLookupSelectedEvent(source, title) {
    if (this.dataService.isGainSightPXEnabled) {
      if (title == 'Engine Oil') {
        const partsLookupSelected: any = {
          fluidType: title,
          roNumber: this.estimateCode,
        };
        this.helperService.postGainsightPXEvent('Fluid Type Selected', partsLookupSelected);
      } else {
        const partsLookupSelected: any = {
          roCreationSource: source,
          partName: title,
          roNumber: this.estimateCode,
        };
        this.helperService.postGainsightPXEvent('Part Types Selected', partsLookupSelected);
      }
    }
  }

  setServiceItemWarrantyEligibleFields(serviceItem: any, isSuccess: boolean, data: any) {
    const index = findIndex(serviceItem.tags, { tagType: 'partWarranties' });
    if (isSuccess && data) {
      if (serviceItem?.warranty) {
        serviceItem.warranty.type = data?.warrantyType;
        serviceItem.warranty.replacementType = data?.partWarrantyType;
      }
      if (data?.warrantyType === 'first-time') {
        if (index > -1) {
          serviceItem.tags[index].name = 'Warranty (First Install)';
          serviceItem.tags[index].tooltip = 'Warranty (First Install)';
        }
      }

      else if (data?.warrantyType === 'replacement') {
        if (index > -1) {
          serviceItem.tags[index].name = 'Warranty (Replacement)';
          serviceItem.tags[index].tooltip = 'Warranty (Replacement)';
        }

        if (data?.partWarrantyType === 'being-replaced') {
          if (data?.selectedPart?.warrantyNumber) {
            serviceItem.warranty.previousWarrantyNumber = data?.selectedPart?.warrantyNumber;
          }

          if (data?.selectedPart?._id) {

            // Only saving _id to get in warranty dialog
            // serviceItem.warranty.previousWarrantyNumber = data?.selectedPart?._id;

            serviceItem.warranty.replacementInvoice = {
              partName: data?.selectedPart?.partName,
              partNumber: data?.selectedPart?.partNumber,
              invoiceDate: data?.selectedPart?.invoiceDate,
              invoiceId: data?.selectedPart?.invoiceId || '',
              invoiceCode: data?.selectedPart?.code,
            };
          }
        } else if (data?.partWarrantyType === 'manually-entered') {
          if (data?.warrantyNumber) {
            serviceItem.warranty.previousWarrantyNumber = data?.warrantyNumber;
            serviceItem.warranty.replacementInvoice = {
              partName: data?.selectedPart?.partName,
              partNumber: data?.selectedPart?.partNumber,
              invoiceDate: data?.selectedPart?.invoiceDate,
              invoiceCode: data?.selectedPart?.invoiceCode,
            };
          }
        }

        if (data?.isSetCostPriceZero) {
          serviceItem.cost = 0;
          serviceItem.price = 0;
          serviceItem.isSetCostPriceZero = data?.isSetCostPriceZero;
        }

        // Tires only
        if (serviceItem.type === 'tire' && data?.isSetPriceZeroOnly) {
          serviceItem.price = 0;
          serviceItem.isSetPriceZeroOnly = data?.isSetPriceZeroOnly;
        }
      }
      else {
        serviceItem.isWarrantyEligible = false;
        serviceItem.tags.splice(index, 1);
      }
    } else {
      if (index > -1) {
        serviceItem.isWarrantyEligible = false;
        serviceItem.warranty = {};
        serviceItem.tags.splice(index, 1);
      }
    }
  }

  openWarrantyEligibleDialog(serviceItemFields: any) {
    const ref = this.dialogService.open(WarrantyEligibleDialogComponent, {
      width: '30%',
      styleClass: 'add-dialog warranty-eligible-dialog',
      showHeader: false,
      data: {
        ...serviceItemFields,
        invoicedRO: this.invoicedRO,
        zCode: this.serviceItem.tags.filter(tag => tag.tagType === "warrantyNo"),
        vehicleId: this.vehicleId,
        customerId: this.customerId,
        isWarrantyNumberAddonEnabled: this.dataService.isWarrantyNumberAddonEnabled,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (findIndex(this.serviceItem.tags, { tagType: 'partWarranties' }) === -1) {
          this.serviceItem.tags.push({
            color: '#3D7EAD',
            name: 'Warranty',
            tagType: 'partWarranties',
            tooltip: `Warranty`,
          });
        }
        if (serviceItemFields?.isMultipleItemsView && this.serviceItem?.type === 'bundle') {
          if (data?.length) {
            data.forEach((itemData: any) => {
              const itemIndex = findIndex(this.serviceItem?.subItems, { itemId: itemData?.itemId });
              if (itemIndex > -1) {
                this.serviceItem?.subItems?.forEach((subItem: any) => {
                  if (subItem?.itemId && subItem?.itemId === itemData?.itemId) {
                    this.setServiceItemWarrantyEligibleFields(subItem, !itemData?.isSkipedItem, itemData);
                  }
                });
              }
            });
          } else {
            this.serviceItem?.subItems.forEach((subItem: any) => {
              this.setServiceItemWarrantyEligibleFields(subItem, isSuccess, null);
            });
          }
        } else {
          this.setServiceItemWarrantyEligibleFields(this.serviceItem, isSuccess, data);
        }


        this.dataService.sendData(
          this.dataService.typePassData('update-warranty-item', {
            serviceItem: this.serviceItem,
            serviceIndex: this.cardIndex,
            itemIndex: this.index,
          }),
        );
      }
      onClose.unsubscribe();
    });
  }

  handleOpenItemModal(itemId?: string, isCreateMode: boolean = false, isOpenTireStorageModal = true) {
    if ((!isCreateMode && !itemId) || this.isArchivedRO) {
      return;
    }

    // if(this.serviceItem?.type === 'tireStorage' && this.isTireStorage2Enabled){
    //   this.openTiresInModal();
    //   return;
    // }

    if (this.isTireStorage2Enabled && this.serviceItem.type === 'tireStorage' && this.serviceItem.tireStorageTemplateId && isOpenTireStorageModal) {
      this.handleOpenTireModal();
      return;
    }

    if (this.serviceItem.lineItemType === 'refund') {
      return;
    }

    if (this.serviceItem.type === 'labor' && this.isOverrideCostWithTechRate && this.serviceItem.avgTechCost > 0) {
      this.serviceItem.cost = this.serviceItem.avgTechCost * this.serviceItem.costEstimatedHours;
    }

    this.setTireExtraFields(this.serviceItem);

    this.appOpenItemModal.emit({
      title: itemId ? '' : this.title,
      type: this.type,
      serviceId: this.serviceId,
      itemId: this.serviceItem.itemId,
      index: this.index,
      orderId: this.estimateId,
      serviceItem: this.serviceItem,
      isTireStorage2Enabled: this.isTireStorage2Enabled,
      isChangeInPriceMatrix: this.serviceItem.isChangeInPriceMatrix,
    });

    if (!itemId) {
      this.deleteItem();
    }
  }

  handleOpenTireModal() {
    const tire = {
      _id: this.serviceItem.tireStorageTemplateId,
      title: this.serviceItem.title,
      titleFR: this.serviceItem.titleFR,
      count: this.serviceItem.count || '',
      pricingType: this.serviceItem.pricingType,
      cost: this.serviceItem.cost,
      price: this.serviceItem.price,
      associatedInspection: this.serviceItem.associatedInspection,
      salesCode: this.serviceItem.salesCode,
      category: this.serviceItem?.category,
      internalNotes: this.serviceItem.internalNotes,
      isTaxable: this.serviceItem.isTaxable,
      displayHoursOnOrder: this.serviceItem.displayHoursOnOrder,
      displayDescOnOrder: this.serviceItem.displayDescOnOrder,
      commissionable: this.serviceItem.commissionable,
      status: this.serviceItem.status,
    };

    if (this.serviceItem.pricingType && this.serviceItem.pricingType === 'flatFee' && Number(this.serviceItem.count)) {
      tire.price = this.serviceItem.price * Number(this.serviceItem.count);
      tire.cost = this.serviceItem.cost * Number(this.serviceItem.count);
    }
    const ref = this.dialogService.open(TireStorageDetailsComponent, {
      width: '30%',
      styleClass: 'add-dialog item-dialog new-part',
      showHeader: false,
      data: {
        tireStorage: tire,
        isOpenFromRO: true,
        isFinalizedRo: this.isFinalizedRo,
        invoicedRO: this.invoicedRO
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, tireStorageTemplate }) => {
      if (isSuccess && tireStorageTemplate) {
        (this.serviceItem.title = tireStorageTemplate.title),
          (this.serviceItem.titleFR = tireStorageTemplate.titleFR),
          // this.serviceItem.count = tireStorageTemplate.count || '',
          (this.serviceItem.salesCode = tireStorageTemplate.salesCode);
        (this.serviceItem.pricingType = tireStorageTemplate.pricingType),
          (this.serviceItem.cost = tireStorageTemplate.cost),
          (this.defaultService.cost = tireStorageTemplate.cost),
          (this.serviceItem.price = tireStorageTemplate.price),
          (this.defaultService.price = tireStorageTemplate.price),
          (this.serviceItem.internalNotes = tireStorageTemplate.internalNotes),
          (this.serviceItem.isTaxable = tireStorageTemplate.isTaxable),
          (this.serviceItem.displayHoursOnOrder = tireStorageTemplate.displayHoursOnOrder),
          (this.serviceItem.displayDescOnOrder = tireStorageTemplate.displayDescOnOrder),
          (this.serviceItem.commissionable = tireStorageTemplate.commissionable),
          (this.serviceItem.status = tireStorageTemplate.status);
        this.serviceItem.originalCost = tireStorageTemplate.cost;
        this.serviceItem.originalPrice = tireStorageTemplate.price;

        if (this.dataService.isSalesCodeEnabled) this.serviceItem.tags = this.helperService.updateClassficationServiceItemTag(this.serviceItem.tags, this.serviceItem);
        if (this.serviceItem.count !== tireStorageTemplate.count) {
          this.handleChange('count', tireStorageTemplate.count);
        } else this.setPriceCostTS();
        this.saveServiceItem();
      }

      onClose.unsubscribe();
    });
  }

  openEditQuantityPopupModal(itemId: string, lineCartId: string) {
    if (!itemId || this.isArchived || !lineCartId) {
      return;
    }

    this.appHandleOnlinOrderAction.emit({
      title: itemId ? '' : this.title,
      type: this.type,
      serviceId: this.serviceId,
      itemId: itemId,
      index: this.index,
      orderId: this.estimateId,
      serviceItem: this.serviceItem,
      lineCartId: lineCartId,
    });
  }

  handleRemoveItem() {
    this.deleteItem();
    this.itemResults = [];
  }

  calculatePrice() {
    if (!(this.serviceItem.isFlatRateItem || this.serviceItem.type === 'bundle')) {
      this.serviceItem.subTotal = this.serviceItem.price * this.serviceItem.count;
    }

    this.calculateTotal.emit(true);
  }

  onDiscountChange(type: string, value: any, item: any) {
    if (type === 'type') {
      this.discountType.type = value.type;
      this.discountType.value = item?.discount?.value;
      if (this.discountType.type === 'percentage' && this.discountType.value > 100) {
        this.discountType.value = 0;
        item.discount.value = 0;
      }
    } else {
      this.discountType.value = value;
      item.discount.value = value;
    }
  }

  saveDiscount(closeOverlay: any) {
    if (this.checkForInvalidDiscount()) {
      this.calculateDiscountAndValue();
      this.calculatePrice();

      if (closeOverlay) {
        closeOverlay();
        this.updateServiceItem.emit();
      }
    }
  }

  checkForInvalidDiscount() {
    if (!this.discountType) return true;

    const { type, value } = this.discountType;
    let discountAmount = 0;
    let previousDiscountAmount = 0;

    if (type === 'percentage') {
      discountAmount = this.calculationService.roundOff(this.serviceItem.subTotal * (this.calculationService.roundOff(value) / 100));
      previousDiscountAmount = this.calculationService.roundOff(this.serviceItem.subTotal * (this.calculationService.roundOff(this.discount?.percentage) / 100));
    } else {
      discountAmount = this.calculationService.roundOff(value);
      previousDiscountAmount = this.calculationService.roundOff(this.discount?.value);
    }

    if (!this.invoiceType) {
      if (this.remainingAmount + this.discount.value - discountAmount < 0) {
        this.helperService.showToaster('error', 'Discount cannot be greater than Remaining amount');
        return false;
      } else if (discountAmount > this.serviceItem.subTotal) {
        this.helperService.showToaster('error', `Discount cannot be greater than ${this.labels[this.serviceItem.type]} amount`);
        return false;
      }
    }

    const serviceDiscount = this.serviceItem.discount || {
      type: 'value',
      value: 0,
    };

    if (Number(this.serviceItem.discountAmt || 0) === Number(discountAmount || 0)) return;

    let text = `RO# ${this.estimateCode}: Discount of $${Number(discountAmount).toFixed(2)} was added to ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle
      }" to make the net value of ${this.labels[this.serviceItem.type]} $${Number(this.serviceItem.subTotal - discountAmount).toFixed(2)}`;

    if (Number(serviceDiscount.value) > 0) {
      // tslint:disable-next-line: max-line-length
      text = `RO# ${this.estimateCode}: Discount of ${this.labels[this.serviceItem.type]} (${this.serviceItem.title}) in Service "${this.serviceTitle}" was updated from $${Number(previousDiscountAmount).toFixed(2)} to $${Number(discountAmount).toFixed(2)} ${type === 'percentage' ? '(' + Number(serviceDiscount.value).toFixed(2) + '%)' : ''} discount to make the net value of ${this.labels[this.serviceItem.type]} $${Number(this.serviceItem.subTotal - discountAmount,).toFixed(2)}`;
    }
    this.generateActivity.emit({
      entityId: this.serviceId,
      entityType: 'service',
      entityAction: 'updated',
      activityData: {
        type: 'plaintext',
        icon: this.icons[this.serviceItem.type],
      },
      title: `${this.labels[this.serviceItem.type]} discount ${serviceDiscount.value ? 'updated' : 'added'}`,
      text,
      isPrimary: false,
    });

    return true;
  }

  calculateDiscountAndValue() {
    if (!this.discountType) return;

    const { type, value } = this.discountType;

    if (type === 'percentage') {
      this.discount.percentage = value;
      this.discount.value = this.calculationService.roundOff(this.serviceItem.subTotal * (value / 100));
    } else {
      this.discount.value = value;
      this.discount.percentage = (value / this.serviceItem.subTotal) * 100;
      this.discount.percentage = this.calculationService.roundOff(this.discount.percentage);
    }

    this.serviceItem.discount.type = this.discountType.type;
    this.serviceItem.discount.value = this.calculationService.roundOffToDecimalPlaces(this.discountType.value);
  }

  saveServiceItem(payload: any = {}) {
    const { type, title, titleFR, price, count } = this.serviceItem;
    const isValid = !isNaN(price) && !isNaN(count);

    if (type && (title || titleFR) && isValid) {
      if (this.isFlatRateSubItem) {
        this.dataService.sendData(
          this.dataService.typePassData('call-update-service', {
            status: true,
            value: {
              serviceId: this.serviceId,
              itemId: this.serviceItem.itemId,
              subItemId: this.serviceItem._id,
            },
          }),
        );
      } else {
        this.updateServiceItem.emit(payload);
      }
    }
  }

  _updateTags(data: any) {
    this.updateTags.emit(data);
  }

  // Need to find better solution
  estTypeScroll() {
    this.toTop();
  }

  toTop() {
    document.getElementById(`SC${this.serviceId}${this.index}`).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  getTireStorageData(itemId: string): Promise<any> {
    return this.httpService.initItemData('tireStorage', itemId);
  }

  setTiresInfoInspectionData(inspectionItems: any[], tire: any) {
    if (inspectionItems?.length && tire?.tiresInfo && tire.tiresInfo?.length) {
      tire.tiresInfo?.forEach((tireInfo: any) => {
        const insItem = find(inspectionItems, { tireId: tireInfo?._id });
        if (insItem && insItem?.conditions?.length) {
          const treadDepths = insItem?.conditions?.filter((condition: any) => {
            return condition?.isSelected && condition?.name?.indexOf('/ 32') > -1
          });
          if (treadDepths?.length) {
            const replacedValue = replace(replace(treadDepths[0].name, '\"', ''), / /g, '');
            const treadDepth = split(replacedValue, '/')[0];
            tireInfo.treadDepth = treadDepth;
          }
          tireInfo.recommendReplacement = (insItem?.colorIndex !== 0 && insItem?.colorIndex !== -1);
        }
      });
    }
  }

  syncTireStorageData(tire: any, itemId: string) {
    return this.httpService.updateItem({ ...tire, _id: itemId });
  }

  printLabels() {
    this.httpService
      .downloadTireStoragePdf({ orderId: this.estimateId, tireStorageId: this.serviceItem.itemId })
      .then(
        (url) => {
          window.open(url, '_blank');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isPrintingLabel = false;
      });
  }


  async printTireLabel() {
    if (this.isPrintingLabel) {
      return;
    }
    this.isPrintingLabel = true;
    if (this.isTireStorage2Enabled) {
      try {
        const res = await this.getTireStorageData(this.serviceItem.itemId);
        const defaultInfo = res?.item;
        if (defaultInfo && defaultInfo?.tiresInfo?.length) {

          if (this.serviceInspection?.category && this.serviceInspection?.category?.length) {
            const insTireData = this.helperService.deepCopy(defaultInfo);
            const { inspectionItems } = this.serviceInspection?.category[0];
            if (inspectionItems) {
              this.setTiresInfoInspectionData(inspectionItems, insTireData);
              let hasUnsavedChanges: boolean = false;
              for (let i = 0; i < defaultInfo.tiresInfo.length; i++) {
                const actualInfo = defaultInfo.tiresInfo[i];
                const insInfo = insTireData.tiresInfo[i];
                if (actualInfo?.treadDepth !== insInfo.treadDepth ||
                  actualInfo.recommendReplacement !== insInfo.recommendReplacement
                ) {
                  hasUnsavedChanges = true;
                  break;
                }
              }

              if (hasUnsavedChanges) {
                await this.syncTireStorageData(insTireData, this.serviceItem.itemId);
              }
            }
          }
        }
      } catch (err: any) {
        this.helperService.showToaster('error', err);
      } finally {
        this.printLabels();
      }

    } else {
      this.printLabels();
    }


  }

  handleServiceItemAction(option: any) {
    if (['disassociate', 'delete'].includes(option.value)) {
      this.handleDeleteItem(true, 'option.value');
    } else if (['item', 'core'].includes(option.value)) {
      if (!this.serviceItem._id) {
        this.helperService.showToaster('error', 'Please save the RO to add returns or core to this item.');
      } else {
        this.serviceItem.returnType = option.value;
        this.serviceItem.isOrderExist = this.partOrderingTags && this.partOrderingTags.length;
        let index = 0;
        if (this.partOrderingTags && this.partOrderingTags.length) {
          index = this.partOrderingTags.findIndex((obj) => obj.value === 'received');
        }
        if (index < 0) {
          index = this.partOrderingTags.findIndex((obj) => obj.value === 'draft');
          if (index > -1) {
            this.helperService.showToaster('error', 'This part has not been ordered yet');
          } else {
            this.helperService.showToaster('error', 'Item is not delivered, please mark it delivered to proceed.');
          }
        } else {
          if (this.serviceItem.stocked && option.value !== 'core') {
            if (this.isInventoryReturnEnabled) {
              const navigationExtras: NavigationExtras = {
                state: { id: this.serviceItem.itemId },
                replaceUrl: true,
              };
              this.router.navigate(['inventory/stock'], navigationExtras);
            } else {
              this.serviceItem.isOpenFromServiceItem = true;
              this.appOpenReturnDialog.emit(this.serviceItem);
            }
          } else {
            if (['Nexpart', 'PartsTech'].includes(this.serviceItem.itemSource) && option.count) this.serviceItem.isOpenFromServiceItem = true;
            this.appOpenReturnDialog.emit(this.serviceItem);
          }
        }
      }
    } else if (option.value === 'print-label') {
      this.printTireLabel();
    } else if (option.value === 'update-supplier') {
      const preFilledObj: any = {
        title: this.title,
        type: this.type,
        isPreFilledPartFields: true,
      };
      this.serviceItem.preFilledPartFields = preFilledObj;
      this.serviceItem.isOpenFromUpdateSupplier = true;
      this.handleOpenCatalogueDialog.emit(this.serviceItem);
    } else if (option.value === 'inventory') {
      if (!this.serviceItem._id) {
        this.helperService.showToaster('error', 'Please save the RO to add this item to inventory.');
      } else {
        this.serviceItem.addType = option.value;
        let index = 0;
        if (this.partOrderingTags && this.partOrderingTags.length) {
          index = this.partOrderingTags.findIndex((obj) => obj.value === 'received');
        }
        if (index < 0) {
          index = this.partOrderingTags.findIndex((obj) => obj.value === 'draft');
          if (index > -1) {
            this.helperService.showToaster('error', 'This part has not been ordered yet');
          } else {
            index = this.partOrderingTags.findIndex((obj) => obj.value === 'cancelled');
            if (index > -1) {
              this.helperService.showToaster('error', 'Item order is canceled. It cannot be added to inventory');
            } else {
              this.helperService.showToaster('error', 'Item is not delivered, please mark it delivered to proceed.');
            }
          }
        } else {
          if (['Nexpart', 'PartsTech'].includes(this.serviceItem.itemSource) && option.count) this.serviceItem.isOpenFromServiceItem = true;
          this.handleOpenInventoryDialog.emit({ ...this.serviceItem, isOpenFromInventory: true });
        }
      }
    } else if (option.value === 'remove') {
      const isOrdered = findIndex(this.partOrderingTags || [], ({ name }) => {
        return name.startsWith('Ordered: ') || name.startsWith('Delivered: ');
      });
      this.serviceItem.removeFromServiceLine = true;
      this.serviceItem.isOrdered = isOrdered !== -1;
      const payload = {
        orderId: this.estimateId,
        items: [this.serviceItem],
      };

      const ref = this.dialogService.open(PartsOrderingRemoveItemDialogComponent, {
        width: '600px',
        styleClass: `add-dialog part-order-remove-item-dialog`,
        showHeader: false,
        data: payload,
      });

      const onClose = ref.onClose.subscribe(({ data, isSuccess }) => {
        if (isSuccess) {
          const [item] = data;

          if (item.removeFromCart) {
            this.refetchPartsOrderingCart.emit();
          } else {
            this.handleDeleteItem(false);
          }
        }

        onClose.unsubscribe();
      });
      // const isOrdered = findIndex(this.partOrderingTags || [], ({ name }) => {
      //   return name.startsWith('Ordered: ') || name.startsWith('Delivered: ');
      // });

      // this.serviceItem.isOrdered = isOrdered !== -1;
      // this.appHandleOnlinOrderAction.emit({
      //   orderFrom: this.serviceItem.itemSource,
      //   type: this.type,
      //   serviceId: this.serviceId,
      //   index: this.index,
      //   orderId: this.estimateId,
      //   serviceItem: this.serviceItem,
      //   lineCartId: this.serviceItem.lineCartId,
      //   actionType: option.value,
      // });
    } else if (option.value === 'duplicate') {
      const serviceItem = this.helperService.deepCopy(this.serviceItem);

      delete serviceItem._id;

      serviceItem.count = serviceItem.originalCount;
      serviceItem.price = serviceItem.originalPrice;
      if (serviceItem.netSubTotal < 0) {
        serviceItem.netSubTotal = Math.abs(serviceItem.netSubTotal);
        serviceItem.subTotal = Math.abs(serviceItem.subTotal);
        serviceItem.taxAmt = Math.abs(serviceItem.taxAmt);
      }
      serviceItem.lineItemType = '';
      serviceItem.tags = [];
      this.insertServiceItem.emit({ index: this.index + 1, item: serviceItem });
    } else if (option.value === 'subletSupplier') {
      this.openSubletSupplierDialog();
    } else if (['stockTransferReceive', 'stockTransferSend'].includes(option.value)) {
      this.redirectToTransferStock(option.value);
    }
  }

  redirectToTransferStock(transferType: string) {
    if (transferType === 'stockTransferReceive') {
      this.serviceItem.transferedVia = 'receiver';
    } else {
      this.serviceItem.transferedVia = 'sender';
    }
    this.createTransferOrderWithItems([this.serviceItem]);
  }

  createTransferOrderWithItems(itemsList: any[]) {
    this.httpService
      .createTransferStockOrder(itemsList)
      .then((res) => {
        if (res) {
          try {
            this.helperService.openPageInNewTab(`${config.redirectUrl.transferStock}/${res._id}`);
          } catch (error) {
            this.helperService.showToaster('error', error);
          }
        }
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      });
  }

  openSubletSupplierDialog() {
    if (this.isArchived || this.isUpdating) {
      return;
    }
    this.dataService.sendData(this.dataService.typePassData('sublet-supplier-dialog', { itemReferenceId: this.serviceItem.itemInternalReference }));
  }

  handleUpdateCost(close: any) {
    if (isNaN(this.serviceItem.updateCost) || this.serviceItem.updateCost === '') {
      return;
    }

    if (!this.isCostUpdateFieldEditable()) {
      this.helperService.showToaster('error', `Please mark the ${this.serviceItem.type} delivered to update the cost`);
      return;
    }

    if (Number(this.serviceItem.price) < Number(this.serviceItem.updateCost)) {
      this.errors.updateCost = "Cost can't be greater than price";
      this.helperService.showToaster('error', this.errors.updateCost);
      return;
    }

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Are you sure you want to update cost?`,
        message: `Updating this cost will unsync this item's cost from ${this.serviceItem.itemSource} cost.`,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      const formatData = {
        actualCost: this.currencyPipe.transform(Number(this.serviceItem.actualCost || 0), this.usd),
        cost: this.currencyPipe.transform(Number(this.serviceItem.cost)),
        updateCost: this.currencyPipe.transform(Number(this.serviceItem.updateCost), this.usd),
      };

      if (isSuccess) {
        this.generateActivity.emit({
          entityId: this.serviceId,
          entityType: 'service',
          entityAction: 'updated',
          activityData: {
            type: 'plaintext',
            icon: this.icons[this.serviceItem.type],
          },
          isPrimary: false,
          title: `${this.serviceItem.itemSource} cost manually updated`,
          text: `${this.serviceItem.title}: ${formatData.actualCost === formatData.cost ? '' : `${this.serviceItem.itemSource} cost - ${formatData.actualCost}, `}item cost manually updated from \
          ${formatData.cost} to ${formatData.updateCost} `,
        });
        this.serviceItem.cost = Number(this.serviceItem.updateCost);
        this.calculateMarkup()
        this.updateServiceItem.emit();
      }

      this.serviceItem.updateCost = '';
      onClose.unsubscribe();
    });

    if (close) close();
  }

  calculateMarkup() {
    if (!this.serviceItem.cost || !this.pricingList?.length) {
      return;
    }

    let markup = 0;
    const items = this.pricingList?.find((item: any) => item._id === this.serviceItem.pricing?.pricingId)?.items;
    const itemsLength = items?.length || 0;

    if (itemsLength) {
      for (let i = 0; i < itemsLength; i++) {
        const item = items[i];
        if (this.serviceItem.cost >= item.min && this.serviceItem.cost <= item.max) {
          markup = item.markup;
          break;
        }
      }
    }
    const price: any = this.calculationService.calculateMarkUpPrice(this.serviceItem.cost, markup);

    if (this.serviceItem?.pricing?.name !== 'No pricing rules') {
      this.serviceItem.price = this.calculationService.roundOff(price);
    }
  }

  handleNegativeDiscountPrompt(type: string, serviceItem: any) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `The order value can not be negative.`,
        message: `This discount will be added as a 0$ discount. Are you sure you want to continue?`,
        button: {
          success: { title: 'Add the discount line item with discount value = $0' },
          cancel: { title: 'Do not add the discount' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        serviceItem.discountValue = 0;
        this.handleSelect(type, serviceItem);
      }

      onClose.unsubscribe();
    });
  }

  fetchStockDetails(event: Event) {
    if (this.isStocksLoading) return;
    this.isStocksLoading = true;
    if (this.serviceItem.stocked && this.serviceItem.itemId) {
      this.httpService
        .getInvDetailsFormLineItem(this.serviceItem.itemId)
        .then(
          (data) => {
            if (data) {
              this.stockTooltip = `\
                Qty on hand: ${Number(data?.countInHand || 0)}
                Qty available: ${Number(data?.countAvailable || 0)}\
                `;
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isStocksLoading = false;
        });
    }
  }

  isManualOrderExist() {
    if (this.partOrderingTags && this.partOrderingTags.length) {
      for (let i = 0; i < this.partOrderingTags.length; i++) {
        const { value } = this.partOrderingTags[i];

        if (['ordered', 'draft', 'received'].includes(value)) {
          return true;
        }
      }
    }

    return false;
  }

  onTagClick(tag: any) {
    if (tag.name?.startsWith('Core: ')) {
      //Check has been added against ticket ALP-15671
      if (this.serviceItem?.isManualOrderItem) {
        const index = findIndex(this.partOrderingTags, { value: 'received' });
        if (index > -1) {
          const manualOrderItem: any = this.getManualOrderPOItem(this.serviceItem.itemId);
          if (manualOrderItem) {
            manualOrderItem.returnType = 'core';
            this.appOpenReturnDialog.emit(manualOrderItem);
          }
        } else {
          this.helperService.showToaster('error', 'To add/update core item must be in delivered state');
        }
      } else {
        this.serviceItem.returnType = 'core';
        this.appOpenReturnDialog.emit(this.serviceItem);
      }
    } else if (['Code Unassigned', 'SC Unassigned'].includes(tag?.name)) {
      const data = {
        item: this.helperService.deepCopy(this.serviceItem),
        openFrom: 'service-item',
      };
      //this.appOpenAssignSaleCodeModal.emit(data);
    }
    else if (tag?.tagType === "partWarranties" || tag?.tagType === "warrantyNo") {
      this.openWarrantyEligibleDialog({
        itemTitle: this.serviceItem?.title || '',
        itemId: this.serviceItem.itemId,
        partNumber: this.serviceItem?.code || '',
        type: this.serviceItem.type,
        warranty: { ...this.serviceItem.warranty },
      });
    }
  }

  getManualOrderPOItem(serviceItemId: string): any {
    let item: any = null;
    if (this.dataService.manualOrderPO?.length) {
      const manualOrders: any[] = this.dataService.manualOrderPO;
      manualOrders.forEach((manualOrder: any) => {
        if (manualOrder?.qoute?.orders?.length) {
          manualOrder?.qoute?.orders?.forEach((order: any) => {
            if (!item) {
              item = find(order.items, { itemId: serviceItemId });
              if (item) {
                item.supplier = manualOrder?.qoute?.supplier;
                item.supplierInvoicedNo = manualOrder?.qoute?.supplierInvoicedNo;
                item.count = item.quantity;
              }
            }
          });
        }
      });
    }

    return item;
  }

  async openPartsOrderQtyOverlay() {
    this.serviceItem.updateCount = this.serviceItem.count;
    this.qtyUpdateError = '';

    try {
      if (this.serviceItem.itemSource === 'TireHub') {
        this.isCheckingAvailability = true;
        const data = await this.httpService.getTireHubInventoryItem({
          orderItemId: this.serviceItem.orderItemId,
          warehouseId: this.serviceItem.storeId,
        });

        if (data?.totalAvailable) {
          this.availableQty = data.totalAvailable;
        }
      } else if (this.serviceItem.itemSource === 'TireConnect') {
        this.isCheckingAvailability = true;
        const orderItemId = this.serviceItem.orderItemId.split('-').pop();
        const data = await this.httpService.getTireConnectCartDetails(orderItemId, { warehouseId: this.serviceItem.storeId });

        if (data?.tire?.length) {
          const [tire] = data.tire;
          this.availableQty = tire.totalAvailable;
        }
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isCheckingAvailability = false;
    }
  }

  openPartsOrderingPage(source: string, partNumber = '') {
    const data: any = {
      source,
      partNumber,
      serviceId: '',
      actionType: 'open-parts-ordering-cart',
    };
     if(source === 'Nexpart') {
      data.serviceId = this.serviceId;
    //   data.nexPartCartPayload = {
        // Parts: {
        //   Part: [{
        //     PartNumber: this.serviceItem?.itemSourceId,
        //     LineCode: this.serviceItem?.lineCartId,
        //     OrderQty: this.serviceItem?.count,
        //     PartType: this.serviceItem?.PartType,
        //     PartIdentifier: this.serviceItem?.title || this.serviceItem?.titleFR,
        //     MfgCode: this.serviceItem?.MfgCode,
        //     BranchId: this.serviceItem?.BranchId,
        //   }]
        // },
    //     isModifyAutoleapQoute: true,
    //     isFromDeferredService: true,
    //   }
    }
    this.appHandleOnlinOrderAction.emit(data);
  }

  handleDeliverOrder() {
    const ordered = find(this.partOrderingTags, ({ name }) => {
      return name.startsWith('Ordered: ');
    });

    if(Object.keys(ordered || {})?.length) {
      this.dataService.sendData(
        this.dataService.typePassData('open-deliver-order-modal', {
          qouteId: ordered?.apiToken,
          itemSource: ordered?.orderSource
        }),
      );
    }
  }

  isPartOrdered(): boolean {
    const ordered = find(this.partOrderingTags, ({ name }) => {
      return name.startsWith('Ordered: ');
    });

    return (Object.keys(ordered || {})?.length > 0);
  }


  checkOnlineOrderingNexPartValidation() {
    const nCount = Number(this.serviceItem.updateCount);
    const oCount = Number(this.serviceItem.count);
    
    //if (oCount === nCount) return;

    // if (!nCount) {
    //   //this.helperService.showToaster('error', 'New quantity must be greater than 0');
    //   return 'New quantity must be greater than 0';
    // }

    const ordered = find(this.partOrderingTags, ({ name }) => {
      return name.startsWith('Ordered: ');
    });

    if (ordered) { 
      this.isValidNexPartEdit = false;
      return 'Unable to edit quantity since the order is yet to be delivered';
    }

    const delivered = find(this.partOrderingTags, ({ name }) => {
      return name.startsWith('Delivered: ');
    });

    if (delivered && nCount > oCount) { 
      this.isValidNexPartEdit = false;
      return 'Please place a new order from NexPart to acquire more quantity of this item';
    }

    this.isValidNexPartEdit = true;
  }

  async updatePartsOrderItemCount(close: any) {
    const nCount = Number(this.serviceItem.updateCount);
    const oCount = Number(this.serviceItem.count);

    if (oCount === nCount) return;

    if (!nCount) {
      this.helperService.showToaster('error', 'New quantity must be greater than 0');
      return;
    }

    this.isUpdatingQuantity = true;
    this.qtyUpdateError = '';

    try {
      let data: any;

      const ordered = find(this.partOrderingTags, ({ name }) => {
        return name.startsWith('Ordered: ') || name.startsWith('Delivered: ');
      });

      if (ordered) {
        // 'ordered', 'cancelled', 'received'
        const otherCounts = { orderedCount: 0 };

        try {
          const orderedTag = find(this.partOrderingTags, ({ value }) => ['ordered', 'received'].includes(value));

          if (orderedTag?.qtyOrdered) {
            otherCounts.orderedCount = orderedTag.qtyOrdered;
          }
        } catch (err) {
          console.log(err);
        }
        // otherCounts.orderedCount = Number(ordered.name.split(': ').pop());

        if (nCount > otherCounts.orderedCount) {
          this.qtyUpdateError = `This part is already ordered and quantity change will not be reflected in the current cart. Go to
          ${this.serviceItem.itemSource} to create new order for additional quantity.`;
          this.helperService.showToaster('error', this.qtyUpdateError);
          return;
        } else if (nCount <= otherCounts.orderedCount) {
          if (!['Nexpart','PartsTech'].includes(this.serviceItem.itemSource)) {
            this.handleChange('count', this.serviceItem.updateCount);
            this.defaultService.count = this.serviceItem.updateCount;
            this.handleBlur('count');
            this.serviceItem.count = this.serviceItem.updateCount;
            this.calculateDotNumbers();
          }

          if (['Nexpart','PartsTech'].includes(this.serviceItem.itemSource) && nCount >= oCount) {
            this.qtyUpdateError = 'Please make sure the new quantity is equal to or less than the quantity originally delivered minus any returned items and items already added back to inventory.';
            return;
          }

          const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
            width: '30%',
            styleClass: 'small-heading-dialog',
            showHeader: false,
            data: {
              styleClassHeading: 'font-14',
              isHTML: true,
              title: `What do you want to do with the unused items?`,
              message: `<p>You have ${ordered?.value} ${otherCounts.orderedCount} of these items, but have reduced the quantity on this estimate to ${nCount}.</p> <br /> <span>What do you want to do with the unused items?</span>`,
              button: {
                success: { title: 'Add to inventory' },
                cancel: { title: 'Return to supplier' },
              },
            },
          });

          const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
            if (isSuccess) {
              this.handleServiceItemAction({ value: 'inventory', count: nCount });
            } else {
              if (data.btn !== 'close') {
                this.handleServiceItemAction({ value: 'item', count: nCount });
              }
            }

            onClose.unsubscribe();
          });
        }
      } else {
        if (this.serviceItem.itemSource === 'PartsTech') {
          if (nCount > 99) {
            this.qtyUpdateError = `New quantity must be less than 100`;
            return;
          }
          const oQuantity = this.helperService.deepCopy(this.serviceItem.count);
          this.serviceItem.count = this.serviceItem.updateCount;
          this.calculateDotNumbers();
          setTimeout(async () => {
            data = await this.httpService.updatePartsTechItemCount({
              orderId: this.estimateId,
              orderItemId: this.serviceItem.orderItemId,
              itemName: this.serviceItem.title,
              quantity: this.serviceItem.updateCount,
              oQuantity: oQuantity, //this.serviceItem.count,
            });
            this.refetchPartsOrderingCart.emit(this.serviceItem.itemSource);
          }, 1000);
        } else if (this.serviceItem.itemSource === 'Nexpart') {
          if (nCount > 99) {
            this.qtyUpdateError = `New quantity must be less than 100`;
            return;
          }
          const oQuantity = this.helperService.deepCopy(this.serviceItem.count);
          this.serviceItem.count = this.serviceItem.updateCount;
          this.saveServiceItem();
          setTimeout(async () => {
            data = await this.httpService.updateNexPartItemCount({
              orderId: this.estimateId,
              orderItemId: this.serviceItem.orderItemId,
              itemName: this.serviceItem.title,
              quantity: this.serviceItem.updateCount,
              oQuantity: oQuantity, //this.serviceItem.count,
            });
            this.refetchPartsOrderingCart.emit(this.serviceItem.itemSource);
          }, 1000);
        } else if (this.serviceItem.itemSource === 'TireHub') {
          if (nCount > this.availableQty) {
            this.qtyUpdateError = `New quantity cannot be greater than available quantity. Please got to ${this.serviceItem.itemSource} to review availability of this part from other supplier`;
            return;
          }

          const oQuantity = this.helperService.deepCopy(this.serviceItem.count);
          this.serviceItem.count = this.serviceItem.updateCount;
          this.calculateDotNumbers();
          data = await this.httpService.updateTireHubItemCount({
            orderId: this.estimateId,
            orderItemId: this.serviceItem.orderItemId,
            warehouseId: this.serviceItem.storeId,
            itemName: this.serviceItem.title,
            quantity: this.serviceItem.updateCount,
            oQuantity: oQuantity, //this.serviceItem.count,
          });
        } else if (this.serviceItem.itemSource === 'TireConnect') {
          if (nCount > this.availableQty) {
            this.qtyUpdateError = `New quantity cannot be greater than available quantity. Please got to ${this.serviceItem.itemSource} to review availability of this part from other supplier`;
            return;
          }

          const oQuantity = this.helperService.deepCopy(this.serviceItem.count);
          this.serviceItem.count = this.serviceItem.updateCount;
          this.calculateDotNumbers();
          data = await this.httpService.updateTireConnectItemCount({
            orderId: this.estimateId,
            warehouseId: this.serviceItem.storeId,
            orderItemId: this.serviceItem.orderItemId,
            itemName: this.serviceItem.title,
            quantity: this.serviceItem.updateCount,
            oQuantity: oQuantity, //this.serviceItem.count,
          });
        } else if (this.serviceItem.itemSource === 'RepairLink') {
          const oQuantity = this.helperService.deepCopy(this.serviceItem.count);
          this.serviceItem.count = this.serviceItem.updateCount;
          this.calculateDotNumbers();
          data = await this.httpService.updateRepairLinkItemCount({
            orderId: this.estimateId,
            warehouseId: this.serviceItem.storeId,
            orderItemId: this.serviceItem.orderItemId,
            itemName: this.serviceItem.title,
            quantity: this.serviceItem.updateCount,
            oQuantity: oQuantity, //this.serviceItem.count,
          });
          this.refetchPartsOrderingCart.emit(this.serviceItem.itemSource);
        } else if (this.serviceItem.itemSource === 'SpeedDial') {
          //  update qty
        }
      }

      //this.refetchPartsOrderingCart.emit(this.serviceItem.itemSource);
      if (close) close();
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isUpdatingQuantity = false;
    }
  }

  handleOpenNotesTab(type) {
    if (this.isArchived && !this.isFinalizedRo) return;
    const data = {
      type: 'itemDescriptionNote',
      notes: this.serviceItem.description,
      serviceId: this.serviceId,
      itemId: this.serviceItem.itemId,
      sideModalStyleClass: 'side-panel-notes',
      title: 'Description-' + this.serviceItem.title,
      subTitle: this.serviceTitle,
      _id: this.serviceItem._id,
      isFinalizedRo: this.isFinalizedRo,
      index: this.index,
    };
    this.dataService.sendData(this.dataService.typeSidebar('sidebar-notes', type, type, data));
  }

  motorDialog() {
    const confirmDismissDialogComponentRef = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        headerIcon: 'fas fa-car font-red-800 font-icon-red',
        // headerIcon: true,
        styleClassHeading: 'font-14',
        title: !this.vehicleId ? 'Vehicle not selected' : 'Vehicle not connected With Motor',
        message: !this.vehicleId
          ? 'To proceed with the Part Lookup, please select a vehicle for the Repair Order.'
          : 'The vehicle on this repair order not connected to Motor. To proceed With the lookup, you must connect the vehicle to Motor.',
        button: {
          success: { title: !this.vehicleId ? 'Select Vehicle' : 'Connect vehicle' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose2 = confirmDismissDialogComponentRef.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        if (!this.vehicleId) {
          this.customer = {
            ...this.customer,
            _id: this.customer.customerId,
          };
          this.appOpenVehicleAction.emit('vehicle-searchbar');
        } else {
          this.appOpenVehicleAction.emit('vehicle-sidebar');
        }
      }
      onClose2.unsubscribe();
    });
  }

  openTireDotNumberModal(event, overlay = false) {
    if (['deferred', 'deferredLocked', 'declined'].includes(this.serviceStatus) || this.isFinalizedRo) {
      return;
    }

    if (overlay) event.stopPropagation();
    const ref = this.dialogService.open(TireDotNumberDialogComponent, {
      width: '30%',
      styleClass: 'add-dialog tire-dot-number-dialog',
      showHeader: false,
      data: {
        count: Number(this.serviceItem.count),
        dotNumbers: this.serviceItem.dotNumbers ? this.serviceItem.dotNumbers : [],
        positionPlaceholder: 'Tire Position',
        dotNumberTitle: 'Tire DOT#',
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, dotNumbers }) => {
      if (isSuccess) {
        const updatedDotNumbers = [];
        dotNumbers.forEach((dotNumber: any) => {
          dotNumber.tirePosition = dotNumber.tirePosition.value;
          if (dotNumber.tooltip) delete dotNumber.tooltip;
          if (!dotNumber.dotNumber) dotNumber.tirePosition = '';
          //Adding a fix for the ALP-18121 - issue #2
          //if (dotNumber.dotNumber && dotNumber.dotNumber.trim() !== '') updatedDotNumbers.push(dotNumber);
          updatedDotNumbers.push(dotNumber);
        });
        this.serviceItem.dotNumbers = updatedDotNumbers;
        this.saveServiceItem();
        this.setDotNumberIcon();
        this.setDotNumberTooltip(dotNumbers);
      }

      onClose.unsubscribe();
    });
  }

  setDotNumberIcon() {
    const dotNumbers = [];
    if (this.serviceItem.dotNumbers && this.serviceItem.dotNumbers.length) {
      this.serviceItem.dotNumbers.forEach((dotNumber: any) => {
        if (dotNumber.dotNumber) dotNumbers.push(dotNumber);
      });
    }
    const count = this.serviceItem.count < 0 ? this.serviceItem.count * -1 : this.serviceItem.count;
    if (count && !dotNumbers) {
      this.dotIcon = 'dot-number-red.svg';
    } else if (count - dotNumbers?.length === count) {
      this.dotIcon = 'dot-number-red.svg';
    } else if (count - dotNumbers?.length === 0) {
      this.dotIcon = 'dot-number-green.svg';
    } else if (count - dotNumbers?.length > 0) {
      this.dotIcon = 'dot-number-yellow.svg';
    } else {
      this.dotIcon = 'dot-number-red.svg';
    }
  }

  setDotNumberTooltip(dotNumbers) {
    this.dotIconTooltip = `
      <div class="" style="min-width: 180px;">
        <div class="font-14 font-bold font-secondary-800 text-white">
          DOT#
        </div>
    `;
    if (dotNumbers && dotNumbers.length) {
      const count = this.serviceItem.count >= 0 ? this.serviceItem.count : this.serviceItem.count * -1;
      for (let i = 0; i < count; i++) {
        this.dotIconTooltip += `
          <div class="font-12 pb-0">
            <span>Tire # ${i + 1} ${dotNumbers[i]?.tirePosition ? '(' + this.getTireHeaderTitle(dotNumbers[i]?.tirePosition) + ')' : ''}: ${dotNumbers[i]?.dotNumber ? dotNumbers[i]?.dotNumber : ' ---'}</span>
          </div>
        `;
      }
    }

    if (this.serviceItem.count && this.serviceItem.count > 0 && !this.serviceItem.dotNumbers?.length) {
      for (var i = 0; i < this.serviceItem.count; i++) {
        this.dotIconTooltip += `
          <div class="font-12 pb-0">
            <span>Tire # ${i + 1}: ${' ---'}</span>
          </div>
        `;
      }
    }

    this.dotIconTooltip += '</div>';
  }

  setTireStorageInfoTooltip(setTSTags = false, isUpdate=true) {
    this.httpService.initItemData('tireStorage', this.serviceItem.itemId).then((res: any) => {
      if (res.item?.tiresInfo) {
        if(setTSTags) this.setTireStorageTags(res.item.tiresInfo, isUpdate);
        // if(this.serviceItem.count > res.item.tiresInfo.length || ){
        this.tireStorageIconTooltip = 'Storage details missing. Click to review.';
        this.tireStorageInfoIcon = 'tire-storage-red-icon.svg';
        if (this.serviceItem.count === res.item.tiresInfo.length) {
          let isCompleted = true;
          res.item.tiresInfo.forEach((element) => {
            const size = this.helperService.tireSizeParser(element?.size);
            //const size = element.size.split('/');
            //if (size[0]?.length && size[1]?.length && size[2]?.length && (element.brand?.brandId || element.brand?._id) && element.model && element.rimType && element.storageLocation?.locationId) {
            if (size?.tireWidth && size?.tireProfile && size?.tireSize && (element.brand?.brandId || element.brand?._id) && element.model && element.rimType && element.storageLocation?.locationId) {
            } else {
              isCompleted = false;
              return;
            }
          });
          if (isCompleted) {
            this.tireStorageInfoIcon = 'tire-storage-green-icon.svg';
            this.tireStorageIconTooltip = 'Storage details added. Click to review.';

          }
        }
      }
    });
  }

  populateTireStorageDescription(tiresDetails: any[]) {
    if(!tiresDetails?.length) return;
    let updTiresInfo = JSON.parse(JSON.stringify(tiresDetails));
    updTiresInfo.forEach(element =>{
      delete element.tireLabel;
      delete element._id;
      delete element.storageLocation;
      delete element.storageBin;
      delete element.treadDepth;
      delete element.tirePosition;
      delete element.recommendReplacement;
    });
    let desc = ``;
    if(!this.helperService.arraysAllObjectsEqual(updTiresInfo)) {
      tiresDetails.forEach((element, index) =>{
        if(element.tireLabel === 'Spare 1') desc = `${desc}S1 -`
        else if(element.tireLabel === 'Spare 2') desc = `${desc}S2 -`
        else if(element.tireLabel) desc = index > 0 ? `${desc}${element.tireLabel.split('(')[1].split(')')[0]} - ` : `${element.tireLabel.split('(')[1].split(')')[0]} - `
        if(element.brand && (element.brand.brandId || element.brand._id)) desc = `${desc} ${element.brand.name} `
        if(element.model) desc = `${desc} ${element.model} `
        if(typeof(element.size) === 'string') desc = `${desc} ${element.size} `
        else if(element.size?.tireWidth && element.size?.tireProfile && element.size?.tireSize) desc = `${desc} ${element.size?.tireWidth}/${element.size?.tireProfile}/${element.size?.tireSize}`
        if(element.rimType) desc = `${desc} | Wheel type: ${element.rimType}`
        desc = `${desc}\n` 
      })  
    }else{
      if(tiresDetails[0].brand && (tiresDetails[0].brand.brandId || tiresDetails[0].brand._id)) desc = `${tiresDetails[0].brand.name} `
      if(tiresDetails[0].model) desc = `${desc} ${tiresDetails[0].model} `
      if(typeof(tiresDetails[0].size) === 'string') desc = `${desc} ${tiresDetails[0].size} `
      else if(tiresDetails[0].size?.tireWidth && tiresDetails[0].size?.tireProfile && tiresDetails[0].size?.tireSize) desc = `${desc} ${tiresDetails[0].size?.tireWidth}/${tiresDetails[0].size?.tireProfile}/${tiresDetails[0].size?.tireSize}`
      if(tiresDetails[0].rimType) desc = `${desc} | Wheel type: ${tiresDetails[0].rimType} x ${tiresDetails.length}`
    }
    this.serviceItem.description = desc;
    this.serviceItem.descriptionFR = desc;
    this.handleBlur('notes');
  }

  setTireStorageTags(tiresInfo, isUpdate=true){
    if(!tiresInfo.length){
      if(findIndex(this.serviceItem.tags, {name: 'Pending'}) === -1) this.serviceItem.tags.push({ name: `Pending`, color: '#889191', tooltip: 'The technician has yet to remove these tires from the vehicle and store them.' });
      return;
    }
    if(findIndex(this.serviceItem.tags, {name: 'Store'}) !== -1) this.serviceItem.tags.splice(findIndex(this.serviceItem.tags, {name: 'Store'}), 1);
      
    tiresInfo.forEach((element) => {
      const size = this.helperService.tireSizeParser(element?.size);
      if(this.serviceItem.tireStorageStatus !== 'return'){
        if (!size?.tireWidth || !size?.tireProfile || !size?.tireSize || !element.brand?.brandId || !element.model || !element.rimType) {
          if(findIndex(this.serviceItem.tags, {name: 'Pending'}) === -1) this.serviceItem.tags.push({ name: `Pending`, color: '#889191', tooltip: 'The technician has yet to remove these tires from the vehicle and store them.' });
        }else if (size?.tireWidth && size?.tireProfile && size?.tireSize && (element.brand?.brandId || element.brand?._id) && element.model && element.rimType && !element.storageLocation?.locationId && this.serviceItem.tireStorageStatus === 'remove') {
          const pendingTagindex = findIndex(this.serviceItem.tags, {name: 'Pending'})
          this.serviceItem.tags.splice(pendingTagindex, 1)
          if(findIndex(this.serviceItem.tags, {name: 'Removed'}) === -1) this.serviceItem.tags.push({ name: `Removed`, color: '#d47877', tooltip: 'The technician has removed these tires from the vehicle but not yet stored them in the warehouse.' });
        }else if (size?.tireWidth && size?.tireProfile && size?.tireSize && (element.brand?.brandId || element.brand?._id) && element.model && element.rimType && element.storageLocation?.locationId) {
          const pendingTagindex = findIndex(this.serviceItem.tags, {name: 'Pending'})
          const removedTagindex = findIndex(this.serviceItem.tags, {name: 'Removed'})
          if(pendingTagindex === -1){
            this.serviceItem.tags.splice(removedTagindex, 1)
          }else{
            this.serviceItem.tags.splice(pendingTagindex, 1)
          }
          const locationTooltip = element.storageBin?.binId ? `${element.storageLocation.name} - ${element.storageBin.name}` : `${element.storageLocation.name}`
          if(findIndex(this.serviceItem.tags, {name: 'Stored'}) === -1) this.serviceItem.tags.push({ name: `Stored`, color: '#00c19d', tooltip: `The technician has stored these tires in ${locationTooltip}` });
          // this.serviceItem.tags.push();
        }
        if(isUpdate) this.saveServiceItem();
      }else if (this.serviceItem.tireStorageStatus === 'return'){
        if(this.serviceItem.isReturned){
          const pendingTagindex = findIndex(this.serviceItem.tags, {name: 'Pending'})
          if(pendingTagindex !== -1) this.serviceItem.tags.splice(pendingTagindex, 1)
          if(findIndex(this.serviceItem.tags, {name: 'Returned'}) === -1) this.serviceItem.tags.push({ name: `Returned`, color: '#d47877', tooltip: 'The technician has installed these tires on the vehicle.' });
        }else{
          if(findIndex(this.serviceItem.tags, {name: 'Pending'}) === -1) this.serviceItem.tags.push({ name: `Pending`, color: '#889191', tooltip: 'The technician has yet to install these tires on the vehicle.' });
        }
        if(isUpdate) this.saveServiceItem();
      }
    });
  }

  getTireHeaderTitle(position: string): string {
    let tireHeaderTitle: string = '';
    switch (position) {
      case 'FL': {
        tireHeaderTitle = 'Front Left';
        break;
      }
      case 'FR': {
        tireHeaderTitle = 'Front Right';
        break;
      }
      case 'RL': {
        tireHeaderTitle = 'Rear Left';
        break;
      }
      case 'RR': {
        tireHeaderTitle = 'Rear Right';
        break;
      }
      case 'S1': {
        tireHeaderTitle = 'Spare 1';
        break;
      }
      case 'S2': {
        tireHeaderTitle = 'Spare 2';
        break;
      }
    }

    return tireHeaderTitle;
  }

  toggleExpand() {
    this.serviceItem.isExpanded = !this.serviceItem.isExpanded;
  }

  // partslookup
  openDialog(data, cardIndex, lineItemIndex, isFromQuickSelection = false) {
    if (isFromQuickSelection) {
      // this.serviceItem.title = data.title,
      // data.partTypeId = this.serviceItem?.partTypeId;
      this.handleSelect('partLookUp', data, null, false, this.serviceItem, this.cardIndex, this.index);
      return;
    }
    // GET LIST AND POPULATE
    if (!this.vehicleId || !this.motorVehicle || !Object.keys(this.motorVehicle)?.length) {
      this.motorDialog();
      return;
    }
    if (this.dataService.isPartLookupModalPopUpInProgress || this.isDialogOpening) return;
    if (this.isDialogOpening || data.type !== 'partLookUp') return;
    this.isDialogOpening = true;
    this.dataService.isPartLookupModalPopUpInProgress = true;
    // check globaly is in progress or not
    if (data.title === 'Engine Oil') {
      this.proceedEngineOilDetails(data, cardIndex, lineItemIndex);
    } else {
      if(!this.isPartsTechConnected && !this.isNexpartConnected) {
        this.dataService.isPartLookupModalPopUpInProgress = false;
        this.isDialogOpening = false;
        this.showCatalogConnectivityInstructionModal();
        return;
      }
      this.proceedPartsLookupDetails(data, cardIndex, lineItemIndex);
    }
  }

  proceedEngineOilDetails(data, cardIndex, lineItemIndex) {
    try {
      this.httpService.getVehicleFluidSpecifications(this.vehicleId, true).then(
        (response: any) => {
          this.isDialogOpening = false;
          const partsLookupDialogComponentRef = this.dialogService.open(EngineOilDialogComponent, {
            styleClass: 'add-dialog engine-oil',
            showHeader: false,
            data: {
              currentLang: this.currentLang,
              isFlatRateSubItem: this.isFlatRateSubItem,
              isPartsTechConnected: this.isPartsTechConnected,
              motorVehicle: this.motorVehicle,
              cardIndex,
              lineItemIndex,
              title: data.title,
              // listData: this.sortParts(response),
              serviceId: this.serviceId,
              estimateId: this.estimateId,
              customer: {
                ...this.customer,
                vehicleId: this.vehicleId,
              },
              getDatalistAPIPayload: {
                partTypeId: data.partTypeId,
                orderId: this.estimateId,
                vehicleId: this.vehicleId,
              },
              engineOilDetails: response?.fliudSpecs[0] || {},
            },
          });

          const onClose = partsLookupDialogComponentRef.onClose.subscribe((itemData) => {
            // this.handleSelect()
            this.dataService.isPartLookupModalPopUpInProgress = false;
            this.isDialogOpening = false;
            if (itemData.confirm && itemData.partsTech && itemData?.data) {
              const payload = {
                source: 'PartsTech',
                serviceId: this.serviceId,
                actionType: 'open-parts-ordering-cart',
                isMultiplePartsTechPartsOrdering: true,
                partNumber: itemData.data.map((res) => res.partNumber),
                lineReplaceItemId: this.isFlatRateSubItem ? this.bundleItem?.subItems?.[lineItemIndex]?.['itemId'] : data.itemInternalReference,
                isFlatRateSubItem: this.isFlatRateSubItem,
                itemIndex: lineItemIndex, // item index inside bundle in case of flat rate
                lineItemIndex: this.bundleLineItemIndex, // service line item where flatRateItem bundle placed;
                bundleId: this.bundleItem?.itemId || '',
              };
              this.appHandleOnlinOrderAction.emit({
                ...payload,
              });

              this.postPartLookUpEvent(itemData.data, 'Engine Oil');
              // for FlatRate Subitem
              if (this.isFlatRateSubItem) {
                this.dataService.sendData(this.dataService.typePassData('update-flat-rate-item-online-partsLookup', payload));
              }
            } else if (itemData.confirm && !itemData.partsTech) {
              const data = {
                isFlatRateSubItem: this.isFlatRateSubItem,
                serviceIndex: cardIndex,
                itemIndex: lineItemIndex, // in case flat rate the line item indicate index of bundle (NOT SERVICE LINE ITEM);
                data: itemData.data,
                bundleLineItemIndex: this.bundleLineItemIndex, //service line item index
              };
              this.removedPartsLookupAndReplace.emit({
                ...data,
              });

              this.postPartLookUpEvent(itemData.data, 'Engine Oil');
              if (this.isFlatRateSubItem) {
                this.dataService.sendData(this.dataService.typePassData('update-flat-rate-item-with-partsLookup', data));
              }
            }

            onClose.unsubscribe();
          });
        },
        (error) => {
          this.isDialogOpening = false;
          if (error?.errorCode === 'emptySupplier') {
            this.redirectManufactureList(this.helperService.getErrorMsg(error.msg));
          } else {
            this.helperService.showToaster('error', this.helperService.getErrorMsg(error));
          }
          this.dataService.isPartLookupModalPopUpInProgress = false;
        },
      );
    } catch (err) {
      this.isDialogOpening = false;
      this.dataService.isPartLookupModalPopUpInProgress = false;
    }
  }

  numberFormat(value: number) {
    if (value > 99) {
      return '99+';
    }
    return round(value, 2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  triggerForceClick() {
    const el: HTMLElement = this.forceClick.nativeElement;
    el.click();
  }

  showCatalogConnectivityInstructionModal() {
    const partsLookupDialogComponentRef = this.dialogService.open(PartsLookupDialogComponent, {
      styleClass: 'add-dialog partslookup-empty-msg',
      showHeader: false,
    });

    const onClose = partsLookupDialogComponentRef.onClose.subscribe((itemData) => {
      onClose.unsubscribe();
    });
  }


  proceedPartsLookupDetails(data, cardIndex, lineItemIndex) {
    try {
      if (!data?.partTypeId) return;
      this.httpService
        .getPartLookupModalDataList({ partTypeId: data.partTypeId, partType: data.title, orderId: this.estimateId, vehicleId: this.vehicleId })
        .then(
          (response: any) => {
            if (response) {
              this.isDialogOpening = false;
              this.serviceItem.partLookupInventoryList = this.sortParts(response)?.inventoryItems;

              // Check if no matching parts are found
              if (!this.serviceItem.partLookupInventoryList?.length) {
                this.helperService.showToaster('success', 'No matching parts found in inventory or catalog for the selected vehicle and part type.');
                // return; // Exit early if no parts found
              }

              if (this.serviceItem.partLookupInventoryList?.length === 1) {
                const item = this.serviceItem.partLookupInventoryList[0];
                this.defaultCheck = true;
                this.onSelectPartLookup(item, true, true, 0);
              }
              this.serviceItem.listLoaded = true;
              if (this.isMultiLocationEnabled && this.serviceItem.partLookupInventoryList?.length) {
                this.serviceItem.partLookupInventoryList.map((item) => this.getQtyOtherLocationTooltip(item.itemInfo))
              }
              if (this.serviceItem.partLookupInventoryList?.length) {
                setTimeout(() => {
                  this.triggerForceClick();
                }, 1000)
              }
            }
          },
          (error) => {
            this.isDialogOpening = false;
            if (error?.errorCode === 'emptySupplier') {
              this.redirectManufactureList(this.helperService.getErrorMsg(error.msg));
            } else {
              this.helperService.showToaster('error', this.helperService.getErrorMsg(error));
            }
            this.dataService.isPartLookupModalPopUpInProgress = false;
          },
        )
        .finally(() => {
          this.dataService.isPartLookupModalPopUpInProgress = false;
        });
    } catch (err) {
      this.isDialogOpening = false;
      this.dataService.isPartLookupModalPopUpInProgress = false;
    }
  }

  onlineOrder(cardIndex, index) {
    if(this.preferredInventoryOnlineLookup === 'partsTech' && !this.isPartsTechConnected) {
      this.helperService.showToaster('error', 'Please configured partsTech ordering integrations from settings');
      return;
    } else if(this.preferredInventoryOnlineLookup === 'nexPart' && !this.isNexpartConnected) {
      this.helperService.showToaster('error', 'Please configured nexPart ordering integrations from settings');
      return;
    }
    const orderSource =  this.preferredInventoryOnlineLookup === 'partsTech' ? 'PartsTech' : 'Nexpart';
    const payload = {
      source: orderSource,
      serviceId: this.serviceId,
      actionType: 'open-parts-ordering-cart',
      isMultiplePartsTechPartsOrdering: true,
      // partNumber: itemData.data.map((res) => res.partNumber),
      lineReplaceItemId: this.isFlatRateSubItem ? this.bundleItem?.subItems?.[index]?.['itemId'] : this.serviceItem.itemInternalReference,
      isFlatRateSubItem: this.isFlatRateSubItem,
      itemIndex: index, // item index inside bundle in case of flat rate
      lineItemIndex: this.bundleLineItemIndex, // service line item where flatRateItem bundle placed;
      bundleId: this.bundleItem?.itemId || '',
      partLookTitle: this.serviceItem.title,
      searchTerm: this.serviceItem.title,
      isFromPartLookup: true
    };
    this.appHandleOnlinOrderAction.emit({
      ...payload,
    });

    this.postPartLookUpEventOnline(this.serviceItem, `Order from ${orderSource}`);
    // for FlatRate Subitem
    if (this.isFlatRateSubItem) {
      this.dataService.sendData(this.dataService.typePassData('update-flat-rate-item-online-partsLookup', payload));
    }
  }

  async onSelectPartLookup(part: any, isChecked: boolean, isFromInventory = false, index) {
    this.disableInventoryOrder = true;
    this.isProcessing = true;

    const selectedItemId = `${part.partId}-${index}`;

    // Handle the addition or removal of items
    if (isChecked) {
      // Add item mapping
      part = {
        ...part.itemInfo,
        itemId: part.itemInfo._id,
        amount: Number(part.itemInfo.cost) * Number(part.itemInfo.count),
        cost: Number(part.itemInfo.cost),
        price: this.setPricingBasedOnShopDetails(part.itemInfo),
        isAddedFromInventory: true,
      };
      if (this.isFlatRateSubItem) {
        part.flatRateAmount = part.amount;
        part.netSubTotal = part.amount;
      }
      part.addedFromLookupDialog = true;
      this.selectedItem[selectedItemId] = part;
    } else {
      delete this.selectedItem[selectedItemId];
    }

    const selectedItemCount = Object.keys(this.selectedItem).length;
    if (selectedItemCount) {
      this.disableInventoryOrder = false;
    }

    this.isProcessing = false;
  }

  async addRepairOrder(cardIndex, lineItemIndex) {
    this.isProcessing = true;
    const items = Object.values(this.selectedItem);
    if (!items?.length) {
      this.isProcessing = false;
      this.helperService.showToaster('error', 'Please select at least one item');
      return;
    }

    try {
      const classificationMap = {};
      const classifications = await this.httpService.getCategoryByQuery({}, [
        ...items
          .map(({ itemInfo }: any) => {
            console.log('==>>', itemInfo);
            if (itemInfo?.taxonomy?.categoryId) {
              return {
                itemType: itemInfo.taxonomy.partTypeName === 'Tire' ? 'tire' : 'part',
                categoryId: itemInfo.taxonomy.categoryId,
                subCategoryId: itemInfo.taxonomy.subCategoryId,
                subSubCategoryId: itemInfo.taxonomy.partTypeId,
              };
            }

            return null;
          })
          .filter((category) => category),
      ]);

      if (classifications?.length) {
        classifications.forEach((classification: any) => {
          const { category, subCategory, subSubCategory } = classification;
          const id = this.createClassificationId(category?.categoryId, subCategory?.subCategoryId, subSubCategory?.subSubCategoryId);
          classificationMap[id] = classification;
        });
      }

      items.forEach((item: any) => {
        const taxonomy = item?.itemInfo?.taxonomy || {};
        const id = this.createClassificationId(taxonomy?.categoryId, taxonomy?.subCategoryId, taxonomy?.partTypeId);
        const classification = classificationMap[id];
        if (classification?._id) {
          item.category = {
            _id: classification._id,
            name: [classification.category?.categoryName, classification.subCategory?.subCategoryName, classification.subSubCategory?.subSubCategoryName].filter((str) => str).join('/'),
            categoryId: classification.category?.categoryId,
            categoryName: classification.category?.categoryName,
            subCategoryId: classification.subCategory?.subCategoryId,
            subCategoryName: classification.subCategory?.subCategoryName,
            subSubCategoryId: classification.subSubCategory?.subSubCategoryId,
            subSubCategoryName: classification.subSubCategory?.subSubCategoryName,
          };
          item.salesCode = this.helperService.assignSalesCode(classification);
        }

        if (this.dataService.isSalesCodeEnabled) {
          item.tags = this.helperService.updateClassficationServiceItemTag(item.tags || [], { ...item, type: 'part' });
        }
      });
    } catch (err) {
      console.log(err);
    }
    this.isProcessing = false;
    this.itemLookupAddToService(cardIndex, lineItemIndex, items);
  }

  itemLookupAddToService(cardIndex, lineItemIndex, itemData) {
    const data = {
      isFlatRateSubItem: this.isFlatRateSubItem,
      serviceIndex: cardIndex,
      itemIndex: lineItemIndex, // in case flat rate the line item indicate index of bundle (NOT SERVICE LINE ITEM);
      data: itemData,
      bundleLineItemIndex: this.bundleLineItemIndex, //service line item index
    };
    this.removedPartsLookupAndReplace.emit({
      ...data,
    });

    if (this.isFlatRateSubItem) {
      this.dataService.sendData(this.dataService.typePassData('update-flat-rate-item-with-partsLookup', data));
    }
    this.postPartLookUpEvent(itemData, 'Inventory');
  }

  createClassificationId(categoryId: string, subCategoryId: string, subSubategoryId: string) {
    return [categoryId, subCategoryId, subSubategoryId].join('-');
  }

  setPricingBasedOnShopDetails(data: any) {
    const shopDetails = find(data?.shopDetails || [], { shopId: this.helperService.getCurrentShopId() });
    if (shopDetails) {
      return shopDetails?.price;
    } else {
      return data.price;
    }
  }

  postPartLookUpEvent(data, source = '') {
    if (this.dataService.isGainSightPXEnabled) {
      data.forEach((element) => {
        const partLookupEndPoints: any = {
          endPoint: source ? source && source === 'Inventory' : data.isAddedFromPartLookup ? 'PL Placeholder' : 'Inventory',
          supplier: element?.supplier?.name || source === 'Inventory' ? 'Inventory- n/a' : '',
          brand: element?.brand?.brandName || source === 'Inventory' ? 'Brand- n/a' : '',
          partName: element.partName || source === 'Inventory' ? element?.title : '',
          partNumber: element.partNumber || source === 'Inventory' ? element?.code : '',
          cost: element.partCost || source === 'Inventory' ? element?.cost : '',
        };

        (<any>window).aptrinsic('track', 'Part Lookup Endpoints', partLookupEndPoints);
      });
    }
  }

  postPartLookUpEventOnline(data, source = '') {
    if (this.dataService.isGainSightPXEnabled) {
      const partLookupEndPoints: any = {
        endPoint: source,
        supplier: `${source} - supplier - n/a`,
        brand: `${source} - brand - n/a'`,
        partName: data?.title || '',
        partNumber: `${source} - part number - n/a`,
        cost: `${source} - cost - n/a`,
      };

      (<any>window).aptrinsic('track', 'Part Lookup Endpoints', partLookupEndPoints);
    }
  }

  getPlaceHolder(type) {
    if (type == 'bundle') {
      return 'Enter flat rate';
    }
    if (!type) return 'Enter name*';
    if (type === 'partLookUp') {
      return 'Select Part Type*';
    }
    if (type === 'tireStorage' && this.isTireStorage2Enabled) {
      return 'Pick Storage Type*';
    } else {
      return `Enter ${this.placeholder[type]} name*`;
    }
  }

  redirectManufactureList(err) {
    this.dataService.sendData({
      type: 'app-toaster',
      status: 'error auto-payment-status-toaster',
      message: {
        heading: '',
        body: this.generateToaster(err),
        buttonClass: 'mr-3 ml-4 add-supplier-button',
        buttonText: 'Select Supplier',
        event: 'redirect-manufacture-list',
      },
    });

    this.cdr.detectChanges();
  }

  generateToaster(err): string {
    return `
      <div class="flex-start-center">
        <div class="mr-4">${err}</div>
      </div>
    `;
  }

  sortParts(parts) {
    parts?.inventoryItems.sort((x, y) => {
      const sortItem = x?.partName.toUpperCase();
      const nextSortItem = y?.partName.toUpperCase();
      if (sortItem < nextSortItem) {
        return -1;
      }
      if (sortItem > nextSortItem) {
        return 1;
      }
      return 0;
    });

    return parts;
  }

  setTireExtraFields(data) {
    if (this.serviceItem.type === 'tire') {
      this.serviceItem.loadIndex = data?.loadIndex || '';
      this.serviceItem.loadIndexDual = data?.loadIndexDual || '';
      this.serviceItem.speedRating = data?.speedRating || '';
      this.serviceItem.loadRange = data?.loadRange || '';
      this.serviceItem.sideWallStyle = data?.sideWallStyle || '';
      this.serviceItem.utqg = data?.utqg || '';
      this.serviceItem.mileageRating = data?.mileageRating || '';
    }
  }

  isCostUpdateFieldEditable() {
    return this.partOrderingTags?.some((t) => t?.value === 'received');
  }

  showTiresOutItemLine() {
    if (this.tireStorageV2OutData?.length) {
      const tiresData =
        this.tireStorageV2OutData?.filter((tireItem: any) => {
          return tireItem?.vehicle && tireItem?.vehicle?.vehicleId === this.vehicleId;
        }) || [];
      if (tiresData?.length) return true;
      return false;
    }
    return false;
  }

  // TiresInOut modal
  openTiresInOutModal(isTireOut = false, data, close: any) {
    if (isTireOut) {
      const tiresData =
        this.tireStorageV2OutData?.filter((tireItem: any) => {
          return tireItem?.vehicle && tireItem?.vehicle?.vehicleId === this.vehicleId;
        }) || [];
      if (tiresData?.length === 1) {
        const data = this.helperService.deepCopy(tiresData[0]);
        data.isTireOut = isTireOut;
        this.serviceItem.description = data.description;
        this.serviceItem.descriptionFR = data.descriptionFR;
        this.handleSelect('tireStorage', data, null, false, this.serviceItem, this.cardIndex, this.index);
      } else {
        const ref = this.dialogService.open(TireInOutModalComponent, {
          width: '1100px',
          styleClass: 'add-dialog tire-in-out-modal',
          showHeader: false,
          data: {
            tireStorageOutV2Data: this.helperService.deepCopy(tiresData) || [],
            customerName: tiresData?.length ? tiresData[0]?.customer?.displayName || tiresData[0].customer?.fullName : this.customer?.displayName || '',
            vehicleName: tiresData?.length ? tiresData[0]?.vehicle?.name : this.vehicleName || '',
            vehicleId: this.vehicleId,
            customerId: this.customerId,
            estimateId: this.estimateId,
            motorVehicle: this.motorVehicle,
            hideAddToStorage: this.hideAddToStorage,
          },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess, item }) => {
          if (isSuccess) {
            const data = find(this.tireStorageV2OutData, { _id: item?._id });
            if (data) {
              data.isTireOut = isTireOut;
              this.serviceItem.description = data.description;
              this.serviceItem.descriptionFR = data.descriptionFR;
              this.handleSelect('tireStorage', data, null, false, this.serviceItem, this.cardIndex, this.index);
            }
          }

          onClose.unsubscribe();
        });
      }
    } else {
      this.handleSelect('tireStorage', data, null, false, this.serviceItem, this.cardIndex, this.index);
    }

    if (close) close();
  }

  openTiresInModal() {
    const ref = this.dialogService.open(NewTireStorageModalComponent, {
      width: '1100px',
      styleClass: 'add-dialog item-dialog new-part tireStorage',
      showHeader: false,
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, order }) => {
      // if (isSuccess) {
      // }

      onClose.unsubscribe();
    });
  }
  togglePopover(event: Event, panel: OverlayPanel) {
    panel.toggle(event);

    // Force inner panel (#op2) to always open on top
    if (panel === this.overlayPanel2) {
      setTimeout(() => {
        const triggerRect = this.innerTrigger.nativeElement.getBoundingClientRect();
        const panelElement = this.overlayPanel2.el.nativeElement;

        panelElement.style.top = `${triggerRect.top - panelElement.offsetHeight - 5}px`; // Move above trigger
        panelElement.style.left = `${triggerRect.left}px`; // Align with trigger
      }, 10);
    }
  }

  closePopover(panel: OverlayPanel) {
    panel.hide();
  }




  showOverlay(event: Event, overlayPanel: OverlayPanel) {
    overlayPanel.show(event);
  }

  hideOverlayWithDelay(overlayPanel: OverlayPanel) {
    this.hideOverlayTimeout = setTimeout(() => {
      overlayPanel.hide();
    }, 100); // Small delay to prevent flickering
  }

  cancelHideOverlay() {
    if (this.hideOverlayTimeout) {
      clearTimeout(this.hideOverlayTimeout);
    }
  }



  onPopoverShow(panel: OverlayPanel, isInnerPanel: boolean = false) {
    if (!panel || !panel.el || !panel.el.nativeElement) {
      return;
    }

    const rect = panel.el.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    let arrowPosition = 'arrow-top'; // Default

    if (rect.top < 50 && rect.bottom < viewportHeight / 2) {
      arrowPosition = 'arrow-bottom';
    } else if (rect.bottom > viewportHeight - 50 && rect.top > viewportHeight / 2) {
      arrowPosition = 'arrow-top';
    } else if (rect.left < 50 && rect.right < viewportWidth / 2) {
      arrowPosition = 'arrow-right';
    } else if (rect.right > viewportWidth - 50 && rect.left > viewportWidth / 2) {
      arrowPosition = 'arrow-left';
    }

    if (isInnerPanel) {
      this.innerArrowPosition = arrowPosition;
    } else {
      this.outerArrowPosition = arrowPosition;
    }
  }

  copyText(text: string, index: number) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.copiedIndex = index;
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  }

  getQtyOtherLocationTooltip(item: any) {
    let otherLocationQty = 0;
    if (Array.isArray(item?.stockDetails) && item?.stockDetails?.length) {
      let locData = [];
      item.stockDetails.forEach((location) => {
        const warehouse = this.warehouses?.records?.find((item) => this.dataService.warehouse?.warehouseId !== item?._id && item?._id === location?.warehouseId);

        if (location?.warehouseId === warehouse?._id) {
          otherLocationQty += location?.countAvailable;
          locData.push({
            countAvailable: this.calculationService.roundOff(location?.countAvailable),
            name: warehouse?.name,
          });
        }
      });
      item.stockDetails = locData;
    }
    item.stockOtherLocationQty = this.calculationService.roundOff(otherLocationQty);
    return item;
  }
}
